// This file is auto-generated by @hey-api/openapi-ts

import { type Client, formDataBodySerializer, type Options as Options2, type TDataShape } from './client';
import { client } from './client.gen';
import type { AppendTextChatMessageApiV1WorkflowWorkflowIdTextChatSessionsRunIdMessagesPostData, AppendTextChatMessageApiV1WorkflowWorkflowIdTextChatSessionsRunIdMessagesPostErrors, AppendTextChatMessageApiV1WorkflowWorkflowIdTextChatSessionsRunIdMessagesPostResponses, ArchiveApiKeyApiV1UserApiKeysApiKeyIdDeleteData, ArchiveApiKeyApiV1UserApiKeysApiKeyIdDeleteErrors, ArchiveApiKeyApiV1UserApiKeysApiKeyIdDeleteResponses, ArchiveServiceKeyApiV1UserServiceKeysServiceKeyIdDeleteData, ArchiveServiceKeyApiV1UserServiceKeysServiceKeyIdDeleteErrors, ArchiveServiceKeyApiV1UserServiceKeysServiceKeyIdDeleteResponses, CompleteTransferFunctionCallApiV1TelephonyTransferResultTransferIdPostData, CompleteTransferFunctionCallApiV1TelephonyTransferResultTransferIdPostErrors, CompleteTransferFunctionCallApiV1TelephonyTransferResultTransferIdPostResponses, CreateApiKeyApiV1UserApiKeysPostData, CreateApiKeyApiV1UserApiKeysPostErrors, CreateApiKeyApiV1UserApiKeysPostResponses, CreateCampaignApiV1CampaignCreatePostData, CreateCampaignApiV1CampaignCreatePostErrors, CreateCampaignApiV1CampaignCreatePostResponses, CreateCredentialApiV1CredentialsPostData, CreateCredentialApiV1CredentialsPostErrors, CreateCredentialApiV1CredentialsPostResponses, CreateFolderApiV1FolderPostData, CreateFolderApiV1FolderPostErrors, CreateFolderApiV1FolderPostResponses, CreateOrUpdateEmbedTokenApiV1WorkflowWorkflowIdEmbedTokenPostData, CreateOrUpdateEmbedTokenApiV1WorkflowWorkflowIdEmbedTokenPostErrors, CreateOrUpdateEmbedTokenApiV1WorkflowWorkflowIdEmbedTokenPostResponses, CreatePhoneNumberApiV1OrganizationsTelephonyConfigsConfigIdPhoneNumbersPostData, CreatePhoneNumberApiV1OrganizationsTelephonyConfigsConfigIdPhoneNumbersPostErrors, CreatePhoneNumberApiV1OrganizationsTelephonyConfigsConfigIdPhoneNumbersPostResponses, CreateRecordingsApiV1WorkflowRecordingsPostData, CreateRecordingsApiV1WorkflowRecordingsPostErrors, CreateRecordingsApiV1WorkflowRecordingsPostResponses, CreateServiceKeyApiV1UserServiceKeysPostData, CreateServiceKeyApiV1UserServiceKeysPostErrors, CreateServiceKeyApiV1UserServiceKeysPostResponses, CreateTelephonyConfigurationApiV1OrganizationsTelephonyConfigsPostData, CreateTelephonyConfigurationApiV1OrganizationsTelephonyConfigsPostErrors, CreateTelephonyConfigurationApiV1OrganizationsTelephonyConfigsPostResponses, CreateTextChatSessionApiV1WorkflowWorkflowIdTextChatSessionsPostData, CreateTextChatSessionApiV1WorkflowWorkflowIdTextChatSessionsPostErrors, CreateTextChatSessionApiV1WorkflowWorkflowIdTextChatSessionsPostResponses, CreateToolApiV1ToolsPostData, CreateToolApiV1ToolsPostErrors, CreateToolApiV1ToolsPostResponses, CreateWorkflowApiV1WorkflowCreateDefinitionPostData, CreateWorkflowApiV1WorkflowCreateDefinitionPostErrors, CreateWorkflowApiV1WorkflowCreateDefinitionPostResponses, CreateWorkflowDraftApiV1WorkflowWorkflowIdCreateDraftPostData, CreateWorkflowDraftApiV1WorkflowWorkflowIdCreateDraftPostErrors, CreateWorkflowDraftApiV1WorkflowWorkflowIdCreateDraftPostResponses, CreateWorkflowFromTemplateApiV1WorkflowCreateTemplatePostData, CreateWorkflowFromTemplateApiV1WorkflowCreateTemplatePostErrors, CreateWorkflowFromTemplateApiV1WorkflowCreateTemplatePostResponses, CreateWorkflowRunApiV1WorkflowWorkflowIdRunsPostData, CreateWorkflowRunApiV1WorkflowWorkflowIdRunsPostErrors, CreateWorkflowRunApiV1WorkflowWorkflowIdRunsPostResponses, DeactivateEmbedTokenApiV1WorkflowWorkflowIdEmbedTokenDeleteData, DeactivateEmbedTokenApiV1WorkflowWorkflowIdEmbedTokenDeleteErrors, DeactivateEmbedTokenApiV1WorkflowWorkflowIdEmbedTokenDeleteResponses, DeleteCredentialApiV1CredentialsCredentialUuidDeleteData, DeleteCredentialApiV1CredentialsCredentialUuidDeleteErrors, DeleteCredentialApiV1CredentialsCredentialUuidDeleteResponses, DeleteDocumentApiV1KnowledgeBaseDocumentsDocumentUuidDeleteData, DeleteDocumentApiV1KnowledgeBaseDocumentsDocumentUuidDeleteErrors, DeleteDocumentApiV1KnowledgeBaseDocumentsDocumentUuidDeleteResponses, DeleteFolderApiV1FolderFolderIdDeleteData, DeleteFolderApiV1FolderFolderIdDeleteErrors, DeleteFolderApiV1FolderFolderIdDeleteResponses, DeleteLangfuseCredentialsApiV1OrganizationsLangfuseCredentialsDeleteData, DeleteLangfuseCredentialsApiV1OrganizationsLangfuseCredentialsDeleteErrors, DeleteLangfuseCredentialsApiV1OrganizationsLangfuseCredentialsDeleteResponses, DeletePhoneNumberApiV1OrganizationsTelephonyConfigsConfigIdPhoneNumbersPhoneNumberIdDeleteData, DeletePhoneNumberApiV1OrganizationsTelephonyConfigsConfigIdPhoneNumbersPhoneNumberIdDeleteErrors, DeletePhoneNumberApiV1OrganizationsTelephonyConfigsConfigIdPhoneNumbersPhoneNumberIdDeleteResponses, DeleteRecordingApiV1WorkflowRecordingsRecordingIdDeleteData, DeleteRecordingApiV1WorkflowRecordingsRecordingIdDeleteErrors, DeleteRecordingApiV1WorkflowRecordingsRecordingIdDeleteResponses, DeleteTelephonyConfigurationApiV1OrganizationsTelephonyConfigsConfigIdDeleteData, DeleteTelephonyConfigurationApiV1OrganizationsTelephonyConfigsConfigIdDeleteErrors, DeleteTelephonyConfigurationApiV1OrganizationsTelephonyConfigsConfigIdDeleteResponses, DeleteToolApiV1ToolsToolUuidDeleteData, DeleteToolApiV1ToolsToolUuidDeleteErrors, DeleteToolApiV1ToolsToolUuidDeleteResponses, DownloadCampaignReportApiV1CampaignCampaignIdReportGetData, DownloadCampaignReportApiV1CampaignCampaignIdReportGetErrors, DownloadCampaignReportApiV1CampaignCampaignIdReportGetResponses, DownloadUsageRunsReportApiV1OrganizationsUsageRunsReportGetData, DownloadUsageRunsReportApiV1OrganizationsUsageRunsReportGetErrors, DownloadUsageRunsReportApiV1OrganizationsUsageRunsReportGetResponses, DownloadWorkflowArtifactApiV1PublicDownloadWorkflowTokenArtifactTypeGetData, DownloadWorkflowArtifactApiV1PublicDownloadWorkflowTokenArtifactTypeGetErrors, DownloadWorkflowArtifactApiV1PublicDownloadWorkflowTokenArtifactTypeGetResponses, DownloadWorkflowReportApiV1WorkflowWorkflowIdReportGetData, DownloadWorkflowReportApiV1WorkflowWorkflowIdReportGetErrors, DownloadWorkflowReportApiV1WorkflowWorkflowIdReportGetResponses, DuplicateWorkflowEndpointApiV1WorkflowWorkflowIdDuplicatePostData, DuplicateWorkflowEndpointApiV1WorkflowWorkflowIdDuplicatePostErrors, DuplicateWorkflowEndpointApiV1WorkflowWorkflowIdDuplicatePostResponses, DuplicateWorkflowTemplateApiV1WorkflowTemplatesDuplicatePostData, DuplicateWorkflowTemplateApiV1WorkflowTemplatesDuplicatePostErrors, DuplicateWorkflowTemplateApiV1WorkflowTemplatesDuplicatePostResponses, GetAmbientNoiseUploadUrlApiV1WorkflowAmbientNoiseUploadUrlPostData, GetAmbientNoiseUploadUrlApiV1WorkflowAmbientNoiseUploadUrlPostErrors, GetAmbientNoiseUploadUrlApiV1WorkflowAmbientNoiseUploadUrlPostResponses, GetApiKeysApiV1UserApiKeysGetData, GetApiKeysApiV1UserApiKeysGetErrors, GetApiKeysApiV1UserApiKeysGetResponses, GetAuthUserApiV1UserAuthUserGetData, GetAuthUserApiV1UserAuthUserGetErrors, GetAuthUserApiV1UserAuthUserGetResponses, GetCampaignApiV1CampaignCampaignIdGetData, GetCampaignApiV1CampaignCampaignIdGetErrors, GetCampaignApiV1CampaignCampaignIdGetResponses, GetCampaignDefaultsApiV1OrganizationsCampaignDefaultsGetData, GetCampaignDefaultsApiV1OrganizationsCampaignDefaultsGetErrors, GetCampaignDefaultsApiV1OrganizationsCampaignDefaultsGetResponses, GetCampaignProgressApiV1CampaignCampaignIdProgressGetData, GetCampaignProgressApiV1CampaignCampaignIdProgressGetErrors, GetCampaignProgressApiV1CampaignCampaignIdProgressGetResponses, GetCampaignRunsApiV1CampaignCampaignIdRunsGetData, GetCampaignRunsApiV1CampaignCampaignIdRunsGetErrors, GetCampaignRunsApiV1CampaignCampaignIdRunsGetResponses, GetCampaignsApiV1CampaignGetData, GetCampaignsApiV1CampaignGetErrors, GetCampaignsApiV1CampaignGetResponses, GetCampaignSourceDownloadUrlApiV1CampaignCampaignIdSourceDownloadUrlGetData, GetCampaignSourceDownloadUrlApiV1CampaignCampaignIdSourceDownloadUrlGetErrors, GetCampaignSourceDownloadUrlApiV1CampaignCampaignIdSourceDownloadUrlGetResponses, GetCredentialApiV1CredentialsCredentialUuidGetData, GetCredentialApiV1CredentialsCredentialUuidGetErrors, GetCredentialApiV1CredentialsCredentialUuidGetResponses, GetCurrentPeriodUsageApiV1OrganizationsUsageCurrentPeriodGetData, GetCurrentPeriodUsageApiV1OrganizationsUsageCurrentPeriodGetErrors, GetCurrentPeriodUsageApiV1OrganizationsUsageCurrentPeriodGetResponses, GetCurrentUserApiV1AuthMeGetData, GetCurrentUserApiV1AuthMeGetErrors, GetCurrentUserApiV1AuthMeGetResponses, GetDailyReportApiV1OrganizationsReportsDailyGetData, GetDailyReportApiV1OrganizationsReportsDailyGetErrors, GetDailyReportApiV1OrganizationsReportsDailyGetResponses, GetDailyRunsDetailApiV1OrganizationsReportsDailyRunsGetData, GetDailyRunsDetailApiV1OrganizationsReportsDailyRunsGetErrors, GetDailyRunsDetailApiV1OrganizationsReportsDailyRunsGetResponses, GetDailyUsageBreakdownApiV1OrganizationsUsageDailyBreakdownGetData, GetDailyUsageBreakdownApiV1OrganizationsUsageDailyBreakdownGetErrors, GetDailyUsageBreakdownApiV1OrganizationsUsageDailyBreakdownGetResponses, GetDefaultConfigurationsApiV1UserConfigurationsDefaultsGetData, GetDefaultConfigurationsApiV1UserConfigurationsDefaultsGetErrors, GetDefaultConfigurationsApiV1UserConfigurationsDefaultsGetResponses, GetDocumentApiV1KnowledgeBaseDocumentsDocumentUuidGetData, GetDocumentApiV1KnowledgeBaseDocumentsDocumentUuidGetErrors, GetDocumentApiV1KnowledgeBaseDocumentsDocumentUuidGetResponses, GetEmbedConfigApiV1PublicEmbedConfigTokenGetData, GetEmbedConfigApiV1PublicEmbedConfigTokenGetErrors, GetEmbedConfigApiV1PublicEmbedConfigTokenGetResponses, GetEmbedTokenApiV1WorkflowWorkflowIdEmbedTokenGetData, GetEmbedTokenApiV1WorkflowWorkflowIdEmbedTokenGetErrors, GetEmbedTokenApiV1WorkflowWorkflowIdEmbedTokenGetResponses, GetFileMetadataApiV1S3FileMetadataGetData, GetFileMetadataApiV1S3FileMetadataGetErrors, GetFileMetadataApiV1S3FileMetadataGetResponses, GetLangfuseCredentialsApiV1OrganizationsLangfuseCredentialsGetData, GetLangfuseCredentialsApiV1OrganizationsLangfuseCredentialsGetErrors, GetLangfuseCredentialsApiV1OrganizationsLangfuseCredentialsGetResponses, GetMpsCreditsApiV1OrganizationsUsageMpsCreditsGetData, GetMpsCreditsApiV1OrganizationsUsageMpsCreditsGetErrors, GetMpsCreditsApiV1OrganizationsUsageMpsCreditsGetResponses, GetNodeTypeApiV1NodeTypesNameGetData, GetNodeTypeApiV1NodeTypesNameGetErrors, GetNodeTypeApiV1NodeTypesNameGetResponses, GetPhoneNumberApiV1OrganizationsTelephonyConfigsConfigIdPhoneNumbersPhoneNumberIdGetData, GetPhoneNumberApiV1OrganizationsTelephonyConfigsConfigIdPhoneNumbersPhoneNumberIdGetErrors, GetPhoneNumberApiV1OrganizationsTelephonyConfigsConfigIdPhoneNumbersPhoneNumberIdGetResponses, GetPresignedUploadUrlApiV1S3PresignedUploadUrlPostData, GetPresignedUploadUrlApiV1S3PresignedUploadUrlPostErrors, GetPresignedUploadUrlApiV1S3PresignedUploadUrlPostResponses, GetPublicTurnCredentialsApiV1PublicEmbedTurnCredentialsSessionTokenGetData, GetPublicTurnCredentialsApiV1PublicEmbedTurnCredentialsSessionTokenGetErrors, GetPublicTurnCredentialsApiV1PublicEmbedTurnCredentialsSessionTokenGetResponses, GetServiceKeysApiV1UserServiceKeysGetData, GetServiceKeysApiV1UserServiceKeysGetErrors, GetServiceKeysApiV1UserServiceKeysGetResponses, GetSignedUrlApiV1S3SignedUrlGetData, GetSignedUrlApiV1S3SignedUrlGetErrors, GetSignedUrlApiV1S3SignedUrlGetResponses, GetTelephonyConfigurationApiV1OrganizationsTelephonyConfigGetData, GetTelephonyConfigurationApiV1OrganizationsTelephonyConfigGetErrors, GetTelephonyConfigurationApiV1OrganizationsTelephonyConfigGetResponses, GetTelephonyConfigurationByIdApiV1OrganizationsTelephonyConfigsConfigIdGetData, GetTelephonyConfigurationByIdApiV1OrganizationsTelephonyConfigsConfigIdGetErrors, GetTelephonyConfigurationByIdApiV1OrganizationsTelephonyConfigsConfigIdGetResponses, GetTelephonyConfigWarningsApiV1OrganizationsTelephonyConfigWarningsGetData, GetTelephonyConfigWarningsApiV1OrganizationsTelephonyConfigWarningsGetErrors, GetTelephonyConfigWarningsApiV1OrganizationsTelephonyConfigWarningsGetResponses, GetTelephonyProvidersMetadataApiV1OrganizationsTelephonyProvidersMetadataGetData, GetTelephonyProvidersMetadataApiV1OrganizationsTelephonyProvidersMetadataGetErrors, GetTelephonyProvidersMetadataApiV1OrganizationsTelephonyProvidersMetadataGetResponses, GetTextChatSessionApiV1WorkflowWorkflowIdTextChatSessionsRunIdGetData, GetTextChatSessionApiV1WorkflowWorkflowIdTextChatSessionsRunIdGetErrors, GetTextChatSessionApiV1WorkflowWorkflowIdTextChatSessionsRunIdGetResponses, GetToolApiV1ToolsToolUuidGetData, GetToolApiV1ToolsToolUuidGetErrors, GetToolApiV1ToolsToolUuidGetResponses, GetTurnCredentialsApiV1TurnCredentialsGetData, GetTurnCredentialsApiV1TurnCredentialsGetErrors, GetTurnCredentialsApiV1TurnCredentialsGetResponses, GetUploadUrlApiV1KnowledgeBaseUploadUrlPostData, GetUploadUrlApiV1KnowledgeBaseUploadUrlPostErrors, GetUploadUrlApiV1KnowledgeBaseUploadUrlPostResponses, GetUploadUrlsApiV1WorkflowRecordingsUploadUrlPostData, GetUploadUrlsApiV1WorkflowRecordingsUploadUrlPostErrors, GetUploadUrlsApiV1WorkflowRecordingsUploadUrlPostResponses, GetUsageHistoryApiV1OrganizationsUsageRunsGetData, GetUsageHistoryApiV1OrganizationsUsageRunsGetErrors, GetUsageHistoryApiV1OrganizationsUsageRunsGetResponses, GetUserConfigurationsApiV1UserConfigurationsUserGetData, GetUserConfigurationsApiV1UserConfigurationsUserGetErrors, GetUserConfigurationsApiV1UserConfigurationsUserGetResponses, GetVoicesApiV1UserConfigurationsVoicesProviderGetData, GetVoicesApiV1UserConfigurationsVoicesProviderGetErrors, GetVoicesApiV1UserConfigurationsVoicesProviderGetResponses, GetWorkflowApiV1WorkflowFetchWorkflowIdGetData, GetWorkflowApiV1WorkflowFetchWorkflowIdGetErrors, GetWorkflowApiV1WorkflowFetchWorkflowIdGetResponses, GetWorkflowCountApiV1WorkflowCountGetData, GetWorkflowCountApiV1WorkflowCountGetErrors, GetWorkflowCountApiV1WorkflowCountGetResponses, GetWorkflowOptionsApiV1OrganizationsReportsWorkflowsGetData, GetWorkflowOptionsApiV1OrganizationsReportsWorkflowsGetErrors, GetWorkflowOptionsApiV1OrganizationsReportsWorkflowsGetResponses, GetWorkflowRunApiV1WorkflowWorkflowIdRunsRunIdGetData, GetWorkflowRunApiV1WorkflowWorkflowIdRunsRunIdGetErrors, GetWorkflowRunApiV1WorkflowWorkflowIdRunsRunIdGetResponses, GetWorkflowRunsApiV1SuperuserWorkflowRunsGetData, GetWorkflowRunsApiV1SuperuserWorkflowRunsGetErrors, GetWorkflowRunsApiV1SuperuserWorkflowRunsGetResponses, GetWorkflowRunsApiV1WorkflowWorkflowIdRunsGetData, GetWorkflowRunsApiV1WorkflowWorkflowIdRunsGetErrors, GetWorkflowRunsApiV1WorkflowWorkflowIdRunsGetResponses, GetWorkflowsApiV1WorkflowFetchGetData, GetWorkflowsApiV1WorkflowFetchGetErrors, GetWorkflowsApiV1WorkflowFetchGetResponses, GetWorkflowsSummaryApiV1WorkflowSummaryGetData, GetWorkflowsSummaryApiV1WorkflowSummaryGetErrors, GetWorkflowsSummaryApiV1WorkflowSummaryGetResponses, GetWorkflowTemplatesApiV1WorkflowTemplatesGetData, GetWorkflowTemplatesApiV1WorkflowTemplatesGetErrors, GetWorkflowTemplatesApiV1WorkflowTemplatesGetResponses, GetWorkflowVersionsApiV1WorkflowWorkflowIdVersionsGetData, GetWorkflowVersionsApiV1WorkflowWorkflowIdVersionsGetErrors, GetWorkflowVersionsApiV1WorkflowWorkflowIdVersionsGetResponses, HandleCloudonixCdrApiV1TelephonyCloudonixCdrPostData, HandleCloudonixCdrApiV1TelephonyCloudonixCdrPostErrors, HandleCloudonixCdrApiV1TelephonyCloudonixCdrPostResponses, HandleCloudonixStatusCallbackApiV1TelephonyCloudonixStatusCallbackWorkflowRunIdPostData, HandleCloudonixStatusCallbackApiV1TelephonyCloudonixStatusCallbackWorkflowRunIdPostErrors, HandleCloudonixStatusCallbackApiV1TelephonyCloudonixStatusCallbackWorkflowRunIdPostResponses, HandleInboundFallbackApiV1TelephonyInboundFallbackPostData, HandleInboundFallbackApiV1TelephonyInboundFallbackPostErrors, HandleInboundFallbackApiV1TelephonyInboundFallbackPostResponses, HandleInboundRunApiV1TelephonyInboundRunPostData, HandleInboundRunApiV1TelephonyInboundRunPostErrors, HandleInboundRunApiV1TelephonyInboundRunPostResponses, HandleInboundTelephonyApiV1TelephonyInboundWorkflowIdPostData, HandleInboundTelephonyApiV1TelephonyInboundWorkflowIdPostErrors, HandleInboundTelephonyApiV1TelephonyInboundWorkflowIdPostResponses, HandlePlivoHangupCallbackApiV1TelephonyPlivoHangupCallbackWorkflowRunIdPostData, HandlePlivoHangupCallbackApiV1TelephonyPlivoHangupCallbackWorkflowRunIdPostErrors, HandlePlivoHangupCallbackApiV1TelephonyPlivoHangupCallbackWorkflowRunIdPostResponses, HandlePlivoRingCallbackApiV1TelephonyPlivoRingCallbackWorkflowRunIdPostData, HandlePlivoRingCallbackApiV1TelephonyPlivoRingCallbackWorkflowRunIdPostErrors, HandlePlivoRingCallbackApiV1TelephonyPlivoRingCallbackWorkflowRunIdPostResponses, HandleTelnyxEventsApiV1TelephonyTelnyxEventsWorkflowRunIdPostData, HandleTelnyxEventsApiV1TelephonyTelnyxEventsWorkflowRunIdPostErrors, HandleTelnyxEventsApiV1TelephonyTelnyxEventsWorkflowRunIdPostResponses, HandleTelnyxTransferResultApiV1TelephonyTelnyxTransferResultTransferIdPostData, HandleTelnyxTransferResultApiV1TelephonyTelnyxTransferResultTransferIdPostErrors, HandleTelnyxTransferResultApiV1TelephonyTelnyxTransferResultTransferIdPostResponses, HandleTwilioStatusCallbackApiV1TelephonyTwilioStatusCallbackWorkflowRunIdPostData, HandleTwilioStatusCallbackApiV1TelephonyTwilioStatusCallbackWorkflowRunIdPostErrors, HandleTwilioStatusCallbackApiV1TelephonyTwilioStatusCallbackWorkflowRunIdPostResponses, HandleVobizHangupCallbackApiV1TelephonyVobizHangupCallbackWorkflowRunIdPostData, HandleVobizHangupCallbackApiV1TelephonyVobizHangupCallbackWorkflowRunIdPostErrors, HandleVobizHangupCallbackApiV1TelephonyVobizHangupCallbackWorkflowRunIdPostResponses, HandleVobizHangupCallbackByWorkflowApiV1TelephonyVobizHangupCallbackWorkflowWorkflowIdPostData, HandleVobizHangupCallbackByWorkflowApiV1TelephonyVobizHangupCallbackWorkflowWorkflowIdPostErrors, HandleVobizHangupCallbackByWorkflowApiV1TelephonyVobizHangupCallbackWorkflowWorkflowIdPostResponses, HandleVobizRingCallbackApiV1TelephonyVobizRingCallbackWorkflowRunIdPostData, HandleVobizRingCallbackApiV1TelephonyVobizRingCallbackWorkflowRunIdPostErrors, HandleVobizRingCallbackApiV1TelephonyVobizRingCallbackWorkflowRunIdPostResponses, HandleVonageEventsApiV1TelephonyVonageEventsWorkflowRunIdPostData, HandleVonageEventsApiV1TelephonyVonageEventsWorkflowRunIdPostErrors, HandleVonageEventsApiV1TelephonyVonageEventsWorkflowRunIdPostResponses, HealthApiV1HealthGetData, HealthApiV1HealthGetErrors, HealthApiV1HealthGetResponses, ImpersonateApiV1SuperuserImpersonatePostData, ImpersonateApiV1SuperuserImpersonatePostErrors, ImpersonateApiV1SuperuserImpersonatePostResponses, InitializeEmbedSessionApiV1PublicEmbedInitPostData, InitializeEmbedSessionApiV1PublicEmbedInitPostErrors, InitializeEmbedSessionApiV1PublicEmbedInitPostResponses, InitiateCallApiV1PublicAgentUuidPostData, InitiateCallApiV1PublicAgentUuidPostErrors, InitiateCallApiV1PublicAgentUuidPostResponses, InitiateCallApiV1TelephonyInitiateCallPostData, InitiateCallApiV1TelephonyInitiateCallPostErrors, InitiateCallApiV1TelephonyInitiateCallPostResponses, InitiateCallByWorkflowUuidApiV1PublicAgentWorkflowWorkflowUuidPostData, InitiateCallByWorkflowUuidApiV1PublicAgentWorkflowWorkflowUuidPostErrors, InitiateCallByWorkflowUuidApiV1PublicAgentWorkflowWorkflowUuidPostResponses, InitiateCallTestApiV1PublicAgentTestUuidPostData, InitiateCallTestApiV1PublicAgentTestUuidPostErrors, InitiateCallTestApiV1PublicAgentTestUuidPostResponses, InitiateCallTestByWorkflowUuidApiV1PublicAgentTestWorkflowWorkflowUuidPostData, InitiateCallTestByWorkflowUuidApiV1PublicAgentTestWorkflowWorkflowUuidPostErrors, InitiateCallTestByWorkflowUuidApiV1PublicAgentTestWorkflowWorkflowUuidPostResponses, ListCredentialsApiV1CredentialsGetData, ListCredentialsApiV1CredentialsGetErrors, ListCredentialsApiV1CredentialsGetResponses, ListDocumentsApiV1KnowledgeBaseDocumentsGetData, ListDocumentsApiV1KnowledgeBaseDocumentsGetErrors, ListDocumentsApiV1KnowledgeBaseDocumentsGetResponses, ListFoldersApiV1FolderGetData, ListFoldersApiV1FolderGetErrors, ListFoldersApiV1FolderGetResponses, ListNodeTypesApiV1NodeTypesGetData, ListNodeTypesApiV1NodeTypesGetErrors, ListNodeTypesApiV1NodeTypesGetResponses, ListPhoneNumbersApiV1OrganizationsTelephonyConfigsConfigIdPhoneNumbersGetData, ListPhoneNumbersApiV1OrganizationsTelephonyConfigsConfigIdPhoneNumbersGetErrors, ListPhoneNumbersApiV1OrganizationsTelephonyConfigsConfigIdPhoneNumbersGetResponses, ListRecordingsApiV1WorkflowRecordingsGetData, ListRecordingsApiV1WorkflowRecordingsGetErrors, ListRecordingsApiV1WorkflowRecordingsGetResponses, ListTelephonyConfigurationsApiV1OrganizationsTelephonyConfigsGetData, ListTelephonyConfigurationsApiV1OrganizationsTelephonyConfigsGetErrors, ListTelephonyConfigurationsApiV1OrganizationsTelephonyConfigsGetResponses, ListToolsApiV1ToolsGetData, ListToolsApiV1ToolsGetErrors, ListToolsApiV1ToolsGetResponses, LoginApiV1AuthLoginPostData, LoginApiV1AuthLoginPostErrors, LoginApiV1AuthLoginPostResponses, MoveWorkflowToFolderApiV1WorkflowWorkflowIdFolderPutData, MoveWorkflowToFolderApiV1WorkflowWorkflowIdFolderPutErrors, MoveWorkflowToFolderApiV1WorkflowWorkflowIdFolderPutResponses, OptionsConfigApiV1PublicEmbedConfigTokenOptionsData, OptionsConfigApiV1PublicEmbedConfigTokenOptionsErrors, OptionsConfigApiV1PublicEmbedConfigTokenOptionsResponses, OptionsInitApiV1PublicEmbedInitOptionsData, OptionsInitApiV1PublicEmbedInitOptionsErrors, OptionsInitApiV1PublicEmbedInitOptionsResponses, OptionsTurnCredentialsApiV1PublicEmbedTurnCredentialsSessionTokenOptionsData, OptionsTurnCredentialsApiV1PublicEmbedTurnCredentialsSessionTokenOptionsErrors, OptionsTurnCredentialsApiV1PublicEmbedTurnCredentialsSessionTokenOptionsResponses, PauseCampaignApiV1CampaignCampaignIdPausePostData, PauseCampaignApiV1CampaignCampaignIdPausePostErrors, PauseCampaignApiV1CampaignCampaignIdPausePostResponses, ProcessDocumentApiV1KnowledgeBaseProcessDocumentPostData, ProcessDocumentApiV1KnowledgeBaseProcessDocumentPostErrors, ProcessDocumentApiV1KnowledgeBaseProcessDocumentPostResponses, PublishWorkflowApiV1WorkflowWorkflowIdPublishPostData, PublishWorkflowApiV1WorkflowWorkflowIdPublishPostErrors, PublishWorkflowApiV1WorkflowWorkflowIdPublishPostResponses, ReactivateApiKeyApiV1UserApiKeysApiKeyIdReactivatePutData, ReactivateApiKeyApiV1UserApiKeysApiKeyIdReactivatePutErrors, ReactivateApiKeyApiV1UserApiKeysApiKeyIdReactivatePutResponses, ReactivateServiceKeyApiV1UserServiceKeysServiceKeyIdReactivatePutData, ReactivateServiceKeyApiV1UserServiceKeysServiceKeyIdReactivatePutErrors, ReactivateServiceKeyApiV1UserServiceKeysServiceKeyIdReactivatePutResponses, RedialCampaignApiV1CampaignCampaignIdRedialPostData, RedialCampaignApiV1CampaignCampaignIdRedialPostErrors, RedialCampaignApiV1CampaignCampaignIdRedialPostResponses, RefreshMcpToolsApiV1ToolsToolUuidMcpRefreshPostData, RefreshMcpToolsApiV1ToolsToolUuidMcpRefreshPostErrors, RefreshMcpToolsApiV1ToolsToolUuidMcpRefreshPostResponses, RenameFolderApiV1FolderFolderIdPutData, RenameFolderApiV1FolderFolderIdPutErrors, RenameFolderApiV1FolderFolderIdPutResponses, ResumeCampaignApiV1CampaignCampaignIdResumePostData, ResumeCampaignApiV1CampaignCampaignIdResumePostErrors, ResumeCampaignApiV1CampaignCampaignIdResumePostResponses, RewindTextChatSessionApiV1WorkflowWorkflowIdTextChatSessionsRunIdRewindPostData, RewindTextChatSessionApiV1WorkflowWorkflowIdTextChatSessionsRunIdRewindPostErrors, RewindTextChatSessionApiV1WorkflowWorkflowIdTextChatSessionsRunIdRewindPostResponses, SaveLangfuseCredentialsApiV1OrganizationsLangfuseCredentialsPostData, SaveLangfuseCredentialsApiV1OrganizationsLangfuseCredentialsPostErrors, SaveLangfuseCredentialsApiV1OrganizationsLangfuseCredentialsPostResponses, SaveTelephonyConfigurationApiV1OrganizationsTelephonyConfigPostData, SaveTelephonyConfigurationApiV1OrganizationsTelephonyConfigPostErrors, SaveTelephonyConfigurationApiV1OrganizationsTelephonyConfigPostResponses, SearchChunksApiV1KnowledgeBaseSearchPostData, SearchChunksApiV1KnowledgeBaseSearchPostErrors, SearchChunksApiV1KnowledgeBaseSearchPostResponses, SetDefaultCallerIdApiV1OrganizationsTelephonyConfigsConfigIdPhoneNumbersPhoneNumberIdSetDefaultCallerPostData, SetDefaultCallerIdApiV1OrganizationsTelephonyConfigsConfigIdPhoneNumbersPhoneNumberIdSetDefaultCallerPostErrors, SetDefaultCallerIdApiV1OrganizationsTelephonyConfigsConfigIdPhoneNumbersPhoneNumberIdSetDefaultCallerPostResponses, SetDefaultOutboundApiV1OrganizationsTelephonyConfigsConfigIdSetDefaultOutboundPostData, SetDefaultOutboundApiV1OrganizationsTelephonyConfigsConfigIdSetDefaultOutboundPostErrors, SetDefaultOutboundApiV1OrganizationsTelephonyConfigsConfigIdSetDefaultOutboundPostResponses, SignupApiV1AuthSignupPostData, SignupApiV1AuthSignupPostErrors, SignupApiV1AuthSignupPostResponses, StartCampaignApiV1CampaignCampaignIdStartPostData, StartCampaignApiV1CampaignCampaignIdStartPostErrors, StartCampaignApiV1CampaignCampaignIdStartPostResponses, TranscribeAudioApiV1WorkflowRecordingsTranscribePostData, TranscribeAudioApiV1WorkflowRecordingsTranscribePostErrors, TranscribeAudioApiV1WorkflowRecordingsTranscribePostResponses, UnarchiveToolApiV1ToolsToolUuidUnarchivePostData, UnarchiveToolApiV1ToolsToolUuidUnarchivePostErrors, UnarchiveToolApiV1ToolsToolUuidUnarchivePostResponses, UpdateCampaignApiV1CampaignCampaignIdPatchData, UpdateCampaignApiV1CampaignCampaignIdPatchErrors, UpdateCampaignApiV1CampaignCampaignIdPatchResponses, UpdateCredentialApiV1CredentialsCredentialUuidPutData, UpdateCredentialApiV1CredentialsCredentialUuidPutErrors, UpdateCredentialApiV1CredentialsCredentialUuidPutResponses, UpdatePhoneNumberApiV1OrganizationsTelephonyConfigsConfigIdPhoneNumbersPhoneNumberIdPutData, UpdatePhoneNumberApiV1OrganizationsTelephonyConfigsConfigIdPhoneNumbersPhoneNumberIdPutErrors, UpdatePhoneNumberApiV1OrganizationsTelephonyConfigsConfigIdPhoneNumbersPhoneNumberIdPutResponses, UpdateRecordingApiV1WorkflowRecordingsIdPatchData, UpdateRecordingApiV1WorkflowRecordingsIdPatchErrors, UpdateRecordingApiV1WorkflowRecordingsIdPatchResponses, UpdateTelephonyConfigurationApiV1OrganizationsTelephonyConfigsConfigIdPutData, UpdateTelephonyConfigurationApiV1OrganizationsTelephonyConfigsConfigIdPutErrors, UpdateTelephonyConfigurationApiV1OrganizationsTelephonyConfigsConfigIdPutResponses, UpdateToolApiV1ToolsToolUuidPutData, UpdateToolApiV1ToolsToolUuidPutErrors, UpdateToolApiV1ToolsToolUuidPutResponses, UpdateUserConfigurationsApiV1UserConfigurationsUserPutData, UpdateUserConfigurationsApiV1UserConfigurationsUserPutErrors, UpdateUserConfigurationsApiV1UserConfigurationsUserPutResponses, UpdateWorkflowApiV1WorkflowWorkflowIdPutData, UpdateWorkflowApiV1WorkflowWorkflowIdPutErrors, UpdateWorkflowApiV1WorkflowWorkflowIdPutResponses, UpdateWorkflowStatusApiV1WorkflowWorkflowIdStatusPutData, UpdateWorkflowStatusApiV1WorkflowWorkflowIdStatusPutErrors, UpdateWorkflowStatusApiV1WorkflowWorkflowIdStatusPutResponses, ValidateUserConfigurationsApiV1UserConfigurationsUserValidateGetData, ValidateUserConfigurationsApiV1UserConfigurationsUserValidateGetErrors, ValidateUserConfigurationsApiV1UserConfigurationsUserValidateGetResponses, ValidateWorkflowApiV1WorkflowWorkflowIdValidatePostData, ValidateWorkflowApiV1WorkflowWorkflowIdValidatePostErrors, ValidateWorkflowApiV1WorkflowWorkflowIdValidatePostResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean, TResponse = unknown> = Options2<TData, ThrowOnError, TResponse> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

/**
 * Initiate Call
 *
 * Initiate a call using the configured telephony provider from web browser. This is
 * supposed to be a test call method for the draft version of the agent.
 */
export const initiateCallApiV1TelephonyInitiateCallPost = <ThrowOnError extends boolean = false>(options: Options<InitiateCallApiV1TelephonyInitiateCallPostData, ThrowOnError>) => (options.client ?? client).post<InitiateCallApiV1TelephonyInitiateCallPostResponses, InitiateCallApiV1TelephonyInitiateCallPostErrors, ThrowOnError>({
    url: '/api/v1/telephony/initiate-call',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Handle Inbound Run
 *
 * Workflow-agnostic inbound dispatcher.
 *
 * All providers can point a single webhook at this endpoint instead of one
 * URL per workflow. The dispatcher resolves the org from the webhook's
 * account_id and the workflow from the called number's
 * ``inbound_workflow_id``. This is what ``configure_inbound`` writes into
 * each provider's resource so per-workflow webhook bookkeeping disappears.
 *
 * Provider-specific signature/timestamp headers are not enumerated here —
 * each provider's ``verify_inbound_signature`` reads its own headers from
 * the dict, so adding a new provider doesn't require changes to this route.
 */
export const handleInboundRunApiV1TelephonyInboundRunPost = <ThrowOnError extends boolean = false>(options?: Options<HandleInboundRunApiV1TelephonyInboundRunPostData, ThrowOnError>) => (options?.client ?? client).post<HandleInboundRunApiV1TelephonyInboundRunPostResponses, HandleInboundRunApiV1TelephonyInboundRunPostErrors, ThrowOnError>({ url: '/api/v1/telephony/inbound/run', ...options });

/**
 * Handle Inbound Fallback
 *
 * Fallback endpoint that returns audio message when calls cannot be processed.
 */
export const handleInboundFallbackApiV1TelephonyInboundFallbackPost = <ThrowOnError extends boolean = false>(options?: Options<HandleInboundFallbackApiV1TelephonyInboundFallbackPostData, ThrowOnError>) => (options?.client ?? client).post<HandleInboundFallbackApiV1TelephonyInboundFallbackPostResponses, HandleInboundFallbackApiV1TelephonyInboundFallbackPostErrors, ThrowOnError>({ url: '/api/v1/telephony/inbound/fallback', ...options });

/**
 * Handle Inbound Telephony
 *
 * [LEGACY] Per-workflow inbound webhook.
 *
 * Superseded by ``POST /inbound/run``, which resolves the workflow from
 * the called number's ``inbound_workflow_id`` and lets a single webhook
 * URL serve every workflow in the org. New integrations should point
 * their provider at ``/inbound/run``; this route is kept only for
 * existing provider configurations that still encode ``workflow_id``
 * in the URL.
 *
 * @deprecated
 */
export const handleInboundTelephonyApiV1TelephonyInboundWorkflowIdPost = <ThrowOnError extends boolean = false>(options: Options<HandleInboundTelephonyApiV1TelephonyInboundWorkflowIdPostData, ThrowOnError>) => (options.client ?? client).post<HandleInboundTelephonyApiV1TelephonyInboundWorkflowIdPostResponses, HandleInboundTelephonyApiV1TelephonyInboundWorkflowIdPostErrors, ThrowOnError>({ url: '/api/v1/telephony/inbound/{workflow_id}', ...options });

/**
 * Complete Transfer Function Call
 *
 * Webhook endpoint to complete the function call with transfer result.
 *
 * Called by Twilio's StatusCallback when the transfer call status changes.
 */
export const completeTransferFunctionCallApiV1TelephonyTransferResultTransferIdPost = <ThrowOnError extends boolean = false>(options: Options<CompleteTransferFunctionCallApiV1TelephonyTransferResultTransferIdPostData, ThrowOnError>) => (options.client ?? client).post<CompleteTransferFunctionCallApiV1TelephonyTransferResultTransferIdPostResponses, CompleteTransferFunctionCallApiV1TelephonyTransferResultTransferIdPostErrors, ThrowOnError>({ url: '/api/v1/telephony/transfer-result/{transfer_id}', ...options });

/**
 * Handle Cloudonix Status Callback
 *
 * Handle Cloudonix-specific status callbacks.
 *
 * Cloudonix sends call status updates to the callback URL specified during call initiation.
 */
export const handleCloudonixStatusCallbackApiV1TelephonyCloudonixStatusCallbackWorkflowRunIdPost = <ThrowOnError extends boolean = false>(options: Options<HandleCloudonixStatusCallbackApiV1TelephonyCloudonixStatusCallbackWorkflowRunIdPostData, ThrowOnError>) => (options.client ?? client).post<HandleCloudonixStatusCallbackApiV1TelephonyCloudonixStatusCallbackWorkflowRunIdPostResponses, HandleCloudonixStatusCallbackApiV1TelephonyCloudonixStatusCallbackWorkflowRunIdPostErrors, ThrowOnError>({ url: '/api/v1/telephony/cloudonix/status-callback/{workflow_run_id}', ...options });

/**
 * Handle Cloudonix Cdr
 *
 * Handle Cloudonix CDR (Call Detail Record) webhooks.
 *
 * Cloudonix sends CDR records when calls complete. The CDR contains:
 * - domain: Used to identify the organization
 * - call_id: Used to find the workflow run
 * - disposition: Call termination status (ANSWER, BUSY, CANCEL, FAILED, CONGESTION, NOANSWER)
 * - duration/billsec: Call duration information
 */
export const handleCloudonixCdrApiV1TelephonyCloudonixCdrPost = <ThrowOnError extends boolean = false>(options?: Options<HandleCloudonixCdrApiV1TelephonyCloudonixCdrPostData, ThrowOnError>) => (options?.client ?? client).post<HandleCloudonixCdrApiV1TelephonyCloudonixCdrPostResponses, HandleCloudonixCdrApiV1TelephonyCloudonixCdrPostErrors, ThrowOnError>({ url: '/api/v1/telephony/cloudonix/cdr', ...options });

/**
 * Handle Plivo Hangup Callback
 *
 * Handle Plivo hangup callbacks.
 */
export const handlePlivoHangupCallbackApiV1TelephonyPlivoHangupCallbackWorkflowRunIdPost = <ThrowOnError extends boolean = false>(options: Options<HandlePlivoHangupCallbackApiV1TelephonyPlivoHangupCallbackWorkflowRunIdPostData, ThrowOnError>) => (options.client ?? client).post<HandlePlivoHangupCallbackApiV1TelephonyPlivoHangupCallbackWorkflowRunIdPostResponses, HandlePlivoHangupCallbackApiV1TelephonyPlivoHangupCallbackWorkflowRunIdPostErrors, ThrowOnError>({ url: '/api/v1/telephony/plivo/hangup-callback/{workflow_run_id}', ...options });

/**
 * Handle Plivo Ring Callback
 *
 * Handle Plivo ring callbacks.
 */
export const handlePlivoRingCallbackApiV1TelephonyPlivoRingCallbackWorkflowRunIdPost = <ThrowOnError extends boolean = false>(options: Options<HandlePlivoRingCallbackApiV1TelephonyPlivoRingCallbackWorkflowRunIdPostData, ThrowOnError>) => (options.client ?? client).post<HandlePlivoRingCallbackApiV1TelephonyPlivoRingCallbackWorkflowRunIdPostResponses, HandlePlivoRingCallbackApiV1TelephonyPlivoRingCallbackWorkflowRunIdPostErrors, ThrowOnError>({ url: '/api/v1/telephony/plivo/ring-callback/{workflow_run_id}', ...options });

/**
 * Handle Telnyx Events
 *
 * Handle Telnyx Call Control webhook events.
 *
 * Telnyx sends all call lifecycle events (call.initiated, call.answered,
 * call.hangup, streaming.started, streaming.stopped) as JSON POST requests.
 */
export const handleTelnyxEventsApiV1TelephonyTelnyxEventsWorkflowRunIdPost = <ThrowOnError extends boolean = false>(options: Options<HandleTelnyxEventsApiV1TelephonyTelnyxEventsWorkflowRunIdPostData, ThrowOnError>) => (options.client ?? client).post<HandleTelnyxEventsApiV1TelephonyTelnyxEventsWorkflowRunIdPostResponses, HandleTelnyxEventsApiV1TelephonyTelnyxEventsWorkflowRunIdPostErrors, ThrowOnError>({ url: '/api/v1/telephony/telnyx/events/{workflow_run_id}', ...options });

/**
 * Handle Telnyx Transfer Result
 *
 * Handle Telnyx Call Control events for the transfer destination leg.
 *
 * The destination leg is dialed by :meth:`TelnyxProvider.transfer_call` with
 * this URL as ``webhook_url``. Telnyx sends every event for that leg here.
 * Outcomes:
 *
 * - ``call.answered``: seed a conference with the destination's live
 * ``call_control_id``, stamp ``conference_id`` onto the TransferContext,
 * and publish ``DESTINATION_ANSWERED`` so ``transfer_call_handler`` can
 * end the pipeline. ``TelnyxConferenceStrategy`` then joins the caller
 * into this conference at pipeline teardown.
 * - ``call.hangup`` pre-answer (no ``conference_id`` on the context):
 * publish ``TRANSFER_FAILED`` so the LLM can recover.
 * - ``call.hangup`` post-answer (``conference_id`` set): the destination
 * left a bridged conference; hang up the caller's leg to tear down the
 * empty bridge (Telnyx's create_conference doesn't accept
 * ``end_conference_on_exit`` on the seed leg).
 *
 * Event references:
 * - call.answered: https://developers.telnyx.com/api-reference/callbacks/call-answered
 * - call.hangup:   https://developers.telnyx.com/api-reference/callbacks/call-hangup
 */
export const handleTelnyxTransferResultApiV1TelephonyTelnyxTransferResultTransferIdPost = <ThrowOnError extends boolean = false>(options: Options<HandleTelnyxTransferResultApiV1TelephonyTelnyxTransferResultTransferIdPostData, ThrowOnError>) => (options.client ?? client).post<HandleTelnyxTransferResultApiV1TelephonyTelnyxTransferResultTransferIdPostResponses, HandleTelnyxTransferResultApiV1TelephonyTelnyxTransferResultTransferIdPostErrors, ThrowOnError>({ url: '/api/v1/telephony/telnyx/transfer-result/{transfer_id}', ...options });

/**
 * Handle Twilio Status Callback
 *
 * Handle Twilio-specific status callbacks.
 */
export const handleTwilioStatusCallbackApiV1TelephonyTwilioStatusCallbackWorkflowRunIdPost = <ThrowOnError extends boolean = false>(options: Options<HandleTwilioStatusCallbackApiV1TelephonyTwilioStatusCallbackWorkflowRunIdPostData, ThrowOnError>) => (options.client ?? client).post<HandleTwilioStatusCallbackApiV1TelephonyTwilioStatusCallbackWorkflowRunIdPostResponses, HandleTwilioStatusCallbackApiV1TelephonyTwilioStatusCallbackWorkflowRunIdPostErrors, ThrowOnError>({ url: '/api/v1/telephony/twilio/status-callback/{workflow_run_id}', ...options });

/**
 * Handle Vobiz Hangup Callback
 *
 * Handle Vobiz hangup callback (sent when call ends).
 *
 * Vobiz sends callbacks to hangup_url when the call terminates.
 * This includes call duration, status, and billing information.
 */
export const handleVobizHangupCallbackApiV1TelephonyVobizHangupCallbackWorkflowRunIdPost = <ThrowOnError extends boolean = false>(options: Options<HandleVobizHangupCallbackApiV1TelephonyVobizHangupCallbackWorkflowRunIdPostData, ThrowOnError>) => (options.client ?? client).post<HandleVobizHangupCallbackApiV1TelephonyVobizHangupCallbackWorkflowRunIdPostResponses, HandleVobizHangupCallbackApiV1TelephonyVobizHangupCallbackWorkflowRunIdPostErrors, ThrowOnError>({ url: '/api/v1/telephony/vobiz/hangup-callback/{workflow_run_id}', ...options });

/**
 * Handle Vobiz Ring Callback
 *
 * Handle Vobiz ring callback (sent when call starts ringing).
 *
 * Vobiz can send callbacks to ring_url when the call starts ringing.
 * This is optional and used for tracking ringing status.
 */
export const handleVobizRingCallbackApiV1TelephonyVobizRingCallbackWorkflowRunIdPost = <ThrowOnError extends boolean = false>(options: Options<HandleVobizRingCallbackApiV1TelephonyVobizRingCallbackWorkflowRunIdPostData, ThrowOnError>) => (options.client ?? client).post<HandleVobizRingCallbackApiV1TelephonyVobizRingCallbackWorkflowRunIdPostResponses, HandleVobizRingCallbackApiV1TelephonyVobizRingCallbackWorkflowRunIdPostErrors, ThrowOnError>({ url: '/api/v1/telephony/vobiz/ring-callback/{workflow_run_id}', ...options });

/**
 * Handle Vobiz Hangup Callback By Workflow
 *
 * Handle Vobiz hangup callback with workflow_id - finds workflow run by call_id.
 */
export const handleVobizHangupCallbackByWorkflowApiV1TelephonyVobizHangupCallbackWorkflowWorkflowIdPost = <ThrowOnError extends boolean = false>(options: Options<HandleVobizHangupCallbackByWorkflowApiV1TelephonyVobizHangupCallbackWorkflowWorkflowIdPostData, ThrowOnError>) => (options.client ?? client).post<HandleVobizHangupCallbackByWorkflowApiV1TelephonyVobizHangupCallbackWorkflowWorkflowIdPostResponses, HandleVobizHangupCallbackByWorkflowApiV1TelephonyVobizHangupCallbackWorkflowWorkflowIdPostErrors, ThrowOnError>({ url: '/api/v1/telephony/vobiz/hangup-callback/workflow/{workflow_id}', ...options });

/**
 * Handle Vonage Events
 *
 * Handle Vonage-specific event webhooks.
 *
 * Vonage sends all call events to a single endpoint.
 * Events include: started, ringing, answered, complete, failed, etc.
 */
export const handleVonageEventsApiV1TelephonyVonageEventsWorkflowRunIdPost = <ThrowOnError extends boolean = false>(options: Options<HandleVonageEventsApiV1TelephonyVonageEventsWorkflowRunIdPostData, ThrowOnError>) => (options.client ?? client).post<HandleVonageEventsApiV1TelephonyVonageEventsWorkflowRunIdPostResponses, HandleVonageEventsApiV1TelephonyVonageEventsWorkflowRunIdPostErrors, ThrowOnError>({ url: '/api/v1/telephony/vonage/events/{workflow_run_id}', ...options });

/**
 * Impersonate
 *
 * Impersonate a user as a super-admin.
 * Internally, Stack Auth requires the **provider user ID** (a UUID-ish string)
 * to create an impersonation session.
 */
export const impersonateApiV1SuperuserImpersonatePost = <ThrowOnError extends boolean = false>(options: Options<ImpersonateApiV1SuperuserImpersonatePostData, ThrowOnError>) => (options.client ?? client).post<ImpersonateApiV1SuperuserImpersonatePostResponses, ImpersonateApiV1SuperuserImpersonatePostErrors, ThrowOnError>({
    url: '/api/v1/superuser/impersonate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Workflow Runs
 *
 * Get paginated list of all workflow runs with organization information.
 * Requires superuser privileges.
 *
 * Filters should be provided as a JSON-encoded array of filter criteria.
 * Example: [{"field": "id", "type": "number", "value": {"value": 680}}]
 */
export const getWorkflowRunsApiV1SuperuserWorkflowRunsGet = <ThrowOnError extends boolean = false>(options?: Options<GetWorkflowRunsApiV1SuperuserWorkflowRunsGetData, ThrowOnError>) => (options?.client ?? client).get<GetWorkflowRunsApiV1SuperuserWorkflowRunsGetResponses, GetWorkflowRunsApiV1SuperuserWorkflowRunsGetErrors, ThrowOnError>({ url: '/api/v1/superuser/workflow-runs', ...options });

/**
 * Validate Workflow
 *
 * Validate all nodes in a workflow to ensure they have required fields.
 *
 * Args:
 * workflow_id: The ID of the workflow to validate
 * user: The authenticated user
 *
 * Returns:
 * Object indicating if workflow is valid and any invalid nodes/edges
 */
export const validateWorkflowApiV1WorkflowWorkflowIdValidatePost = <ThrowOnError extends boolean = false>(options: Options<ValidateWorkflowApiV1WorkflowWorkflowIdValidatePostData, ThrowOnError>) => (options.client ?? client).post<ValidateWorkflowApiV1WorkflowWorkflowIdValidatePostResponses, ValidateWorkflowApiV1WorkflowWorkflowIdValidatePostErrors, ThrowOnError>({ url: '/api/v1/workflow/{workflow_id}/validate', ...options });

/**
 * Create Workflow
 *
 * Create a new workflow from the client
 *
 * Args:
 * request: The create workflow request
 * user: The user to create the workflow for
 */
export const createWorkflowApiV1WorkflowCreateDefinitionPost = <ThrowOnError extends boolean = false>(options: Options<CreateWorkflowApiV1WorkflowCreateDefinitionPostData, ThrowOnError>) => (options.client ?? client).post<CreateWorkflowApiV1WorkflowCreateDefinitionPostResponses, CreateWorkflowApiV1WorkflowCreateDefinitionPostErrors, ThrowOnError>({
    url: '/api/v1/workflow/create/definition',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create Workflow From Template
 *
 * Create a new workflow from a natural language template request.
 *
 * This endpoint:
 * 1. Uses mps_service_key_client to call MPS workflow API
 * 2. Passes organization ID (authenticated mode) or created_by (OSS mode)
 * 3. Creates the workflow in the database
 *
 * Args:
 * request: The template creation request with call_type, use_case, and activity_description
 * user: The authenticated user
 *
 * Returns:
 * The created workflow
 *
 * Raises:
 * HTTPException: If MPS API call fails
 */
export const createWorkflowFromTemplateApiV1WorkflowCreateTemplatePost = <ThrowOnError extends boolean = false>(options: Options<CreateWorkflowFromTemplateApiV1WorkflowCreateTemplatePostData, ThrowOnError>) => (options.client ?? client).post<CreateWorkflowFromTemplateApiV1WorkflowCreateTemplatePostResponses, CreateWorkflowFromTemplateApiV1WorkflowCreateTemplatePostErrors, ThrowOnError>({
    url: '/api/v1/workflow/create/template',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Workflow Count
 *
 * Get workflow counts for the authenticated user's organization.
 *
 * This is a lightweight endpoint for checking if the user has workflows,
 * useful for redirect logic without fetching full workflow data.
 */
export const getWorkflowCountApiV1WorkflowCountGet = <ThrowOnError extends boolean = false>(options?: Options<GetWorkflowCountApiV1WorkflowCountGetData, ThrowOnError>) => (options?.client ?? client).get<GetWorkflowCountApiV1WorkflowCountGetResponses, GetWorkflowCountApiV1WorkflowCountGetErrors, ThrowOnError>({ url: '/api/v1/workflow/count', ...options });

/**
 * Get Workflows
 *
 * Get all workflows for the authenticated user's organization.
 *
 * Returns a lightweight response with only essential fields for listing.
 * Use GET /workflow/fetch/{workflow_id} to get full workflow details.
 */
export const getWorkflowsApiV1WorkflowFetchGet = <ThrowOnError extends boolean = false>(options?: Options<GetWorkflowsApiV1WorkflowFetchGetData, ThrowOnError>) => (options?.client ?? client).get<GetWorkflowsApiV1WorkflowFetchGetResponses, GetWorkflowsApiV1WorkflowFetchGetErrors, ThrowOnError>({ url: '/api/v1/workflow/fetch', ...options });

/**
 * Get Workflow
 *
 * Get a single workflow by ID.
 *
 * If a draft version exists, returns the draft content for editing.
 * Otherwise returns the published version's content.
 */
export const getWorkflowApiV1WorkflowFetchWorkflowIdGet = <ThrowOnError extends boolean = false>(options: Options<GetWorkflowApiV1WorkflowFetchWorkflowIdGetData, ThrowOnError>) => (options.client ?? client).get<GetWorkflowApiV1WorkflowFetchWorkflowIdGetResponses, GetWorkflowApiV1WorkflowFetchWorkflowIdGetErrors, ThrowOnError>({ url: '/api/v1/workflow/fetch/{workflow_id}', ...options });

/**
 * Get Workflow Versions
 *
 * List versions for a workflow, newest first.
 *
 * Pass `limit`/`offset` to page through long histories. With no `limit`,
 * returns every version (legacy behavior).
 */
export const getWorkflowVersionsApiV1WorkflowWorkflowIdVersionsGet = <ThrowOnError extends boolean = false>(options: Options<GetWorkflowVersionsApiV1WorkflowWorkflowIdVersionsGetData, ThrowOnError>) => (options.client ?? client).get<GetWorkflowVersionsApiV1WorkflowWorkflowIdVersionsGetResponses, GetWorkflowVersionsApiV1WorkflowWorkflowIdVersionsGetErrors, ThrowOnError>({ url: '/api/v1/workflow/{workflow_id}/versions', ...options });

/**
 * Publish Workflow
 *
 * Publish the current draft version of a workflow.
 *
 * Drafts are allowed to be incomplete (so the editor can save mid-edit),
 * but a published version is what runtime executes — so this is the gate
 * where the full DTO + graph + trigger-conflict checks must pass.
 */
export const publishWorkflowApiV1WorkflowWorkflowIdPublishPost = <ThrowOnError extends boolean = false>(options: Options<PublishWorkflowApiV1WorkflowWorkflowIdPublishPostData, ThrowOnError>) => (options.client ?? client).post<PublishWorkflowApiV1WorkflowWorkflowIdPublishPostResponses, PublishWorkflowApiV1WorkflowWorkflowIdPublishPostErrors, ThrowOnError>({ url: '/api/v1/workflow/{workflow_id}/publish', ...options });

/**
 * Create Workflow Draft
 *
 * Create a draft version from the current published version.
 *
 * If a draft already exists, returns the existing draft.
 */
export const createWorkflowDraftApiV1WorkflowWorkflowIdCreateDraftPost = <ThrowOnError extends boolean = false>(options: Options<CreateWorkflowDraftApiV1WorkflowWorkflowIdCreateDraftPostData, ThrowOnError>) => (options.client ?? client).post<CreateWorkflowDraftApiV1WorkflowWorkflowIdCreateDraftPostResponses, CreateWorkflowDraftApiV1WorkflowWorkflowIdCreateDraftPostErrors, ThrowOnError>({ url: '/api/v1/workflow/{workflow_id}/create-draft', ...options });

/**
 * Get Workflows Summary
 *
 * Get minimal workflow information (id and name only) for all workflows
 */
export const getWorkflowsSummaryApiV1WorkflowSummaryGet = <ThrowOnError extends boolean = false>(options?: Options<GetWorkflowsSummaryApiV1WorkflowSummaryGetData, ThrowOnError>) => (options?.client ?? client).get<GetWorkflowsSummaryApiV1WorkflowSummaryGetResponses, GetWorkflowsSummaryApiV1WorkflowSummaryGetErrors, ThrowOnError>({ url: '/api/v1/workflow/summary', ...options });

/**
 * Update Workflow Status
 *
 * Update the status of a workflow (e.g., archive/unarchive).
 *
 * Args:
 * workflow_id: The ID of the workflow to update
 * request: The status update request
 *
 * Returns:
 * The updated workflow
 */
export const updateWorkflowStatusApiV1WorkflowWorkflowIdStatusPut = <ThrowOnError extends boolean = false>(options: Options<UpdateWorkflowStatusApiV1WorkflowWorkflowIdStatusPutData, ThrowOnError>) => (options.client ?? client).put<UpdateWorkflowStatusApiV1WorkflowWorkflowIdStatusPutResponses, UpdateWorkflowStatusApiV1WorkflowWorkflowIdStatusPutErrors, ThrowOnError>({
    url: '/api/v1/workflow/{workflow_id}/status',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Move Workflow To Folder
 *
 * Move a workflow into a folder, or to "Uncategorized" (folder_id=null).
 *
 * Validates that the target folder belongs to the caller's organization —
 * the FK alone proves the folder exists, not that the caller may use it.
 */
export const moveWorkflowToFolderApiV1WorkflowWorkflowIdFolderPut = <ThrowOnError extends boolean = false>(options: Options<MoveWorkflowToFolderApiV1WorkflowWorkflowIdFolderPutData, ThrowOnError>) => (options.client ?? client).put<MoveWorkflowToFolderApiV1WorkflowWorkflowIdFolderPutResponses, MoveWorkflowToFolderApiV1WorkflowWorkflowIdFolderPutErrors, ThrowOnError>({
    url: '/api/v1/workflow/{workflow_id}/folder',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update Workflow
 *
 * Update an existing workflow.
 *
 * Args:
 * workflow_id: The ID of the workflow to update
 * request: The update request containing the new name and workflow definition
 *
 * Returns:
 * The updated workflow
 *
 * Raises:
 * HTTPException: If the workflow is not found or if there's a database error
 */
export const updateWorkflowApiV1WorkflowWorkflowIdPut = <ThrowOnError extends boolean = false>(options: Options<UpdateWorkflowApiV1WorkflowWorkflowIdPutData, ThrowOnError>) => (options.client ?? client).put<UpdateWorkflowApiV1WorkflowWorkflowIdPutResponses, UpdateWorkflowApiV1WorkflowWorkflowIdPutErrors, ThrowOnError>({
    url: '/api/v1/workflow/{workflow_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Duplicate Workflow Endpoint
 *
 * Duplicate a workflow including its definition, configuration, recordings, and triggers.
 */
export const duplicateWorkflowEndpointApiV1WorkflowWorkflowIdDuplicatePost = <ThrowOnError extends boolean = false>(options: Options<DuplicateWorkflowEndpointApiV1WorkflowWorkflowIdDuplicatePostData, ThrowOnError>) => (options.client ?? client).post<DuplicateWorkflowEndpointApiV1WorkflowWorkflowIdDuplicatePostResponses, DuplicateWorkflowEndpointApiV1WorkflowWorkflowIdDuplicatePostErrors, ThrowOnError>({ url: '/api/v1/workflow/{workflow_id}/duplicate', ...options });

/**
 * Get Workflow Runs
 *
 * Get workflow runs with optional filtering and sorting.
 *
 * Filters should be provided as a JSON-encoded array of filter criteria.
 * Example: [{"attribute": "dateRange", "value": {"from": "2024-01-01", "to": "2024-01-31"}}]
 */
export const getWorkflowRunsApiV1WorkflowWorkflowIdRunsGet = <ThrowOnError extends boolean = false>(options: Options<GetWorkflowRunsApiV1WorkflowWorkflowIdRunsGetData, ThrowOnError>) => (options.client ?? client).get<GetWorkflowRunsApiV1WorkflowWorkflowIdRunsGetResponses, GetWorkflowRunsApiV1WorkflowWorkflowIdRunsGetErrors, ThrowOnError>({ url: '/api/v1/workflow/{workflow_id}/runs', ...options });

/**
 * Create Workflow Run
 *
 * Create a new workflow run when the user decides to execute the workflow via chat or voice
 *
 * Args:
 * workflow_id: The ID of the workflow to run
 * request: The create workflow run request
 * user: The user to create the workflow run for
 */
export const createWorkflowRunApiV1WorkflowWorkflowIdRunsPost = <ThrowOnError extends boolean = false>(options: Options<CreateWorkflowRunApiV1WorkflowWorkflowIdRunsPostData, ThrowOnError>) => (options.client ?? client).post<CreateWorkflowRunApiV1WorkflowWorkflowIdRunsPostResponses, CreateWorkflowRunApiV1WorkflowWorkflowIdRunsPostErrors, ThrowOnError>({
    url: '/api/v1/workflow/{workflow_id}/runs',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Workflow Run
 */
export const getWorkflowRunApiV1WorkflowWorkflowIdRunsRunIdGet = <ThrowOnError extends boolean = false>(options: Options<GetWorkflowRunApiV1WorkflowWorkflowIdRunsRunIdGetData, ThrowOnError>) => (options.client ?? client).get<GetWorkflowRunApiV1WorkflowWorkflowIdRunsRunIdGetResponses, GetWorkflowRunApiV1WorkflowWorkflowIdRunsRunIdGetErrors, ThrowOnError>({ url: '/api/v1/workflow/{workflow_id}/runs/{run_id}', ...options });

/**
 * Download Workflow Report
 *
 * Download a CSV report of completed runs for a workflow.
 */
export const downloadWorkflowReportApiV1WorkflowWorkflowIdReportGet = <ThrowOnError extends boolean = false>(options: Options<DownloadWorkflowReportApiV1WorkflowWorkflowIdReportGetData, ThrowOnError>) => (options.client ?? client).get<DownloadWorkflowReportApiV1WorkflowWorkflowIdReportGetResponses, DownloadWorkflowReportApiV1WorkflowWorkflowIdReportGetErrors, ThrowOnError>({ url: '/api/v1/workflow/{workflow_id}/report', ...options });

/**
 * Get Workflow Templates
 *
 * Get all available workflow templates.
 *
 * Returns:
 * List of workflow templates
 */
export const getWorkflowTemplatesApiV1WorkflowTemplatesGet = <ThrowOnError extends boolean = false>(options?: Options<GetWorkflowTemplatesApiV1WorkflowTemplatesGetData, ThrowOnError>) => (options?.client ?? client).get<GetWorkflowTemplatesApiV1WorkflowTemplatesGetResponses, GetWorkflowTemplatesApiV1WorkflowTemplatesGetErrors, ThrowOnError>({ url: '/api/v1/workflow/templates', ...options });

/**
 * Duplicate Workflow Template
 *
 * Duplicate a workflow template to create a new workflow for the user.
 *
 * Args:
 * request: The duplicate template request
 * user: The authenticated user
 *
 * Returns:
 * The newly created workflow
 */
export const duplicateWorkflowTemplateApiV1WorkflowTemplatesDuplicatePost = <ThrowOnError extends boolean = false>(options: Options<DuplicateWorkflowTemplateApiV1WorkflowTemplatesDuplicatePostData, ThrowOnError>) => (options.client ?? client).post<DuplicateWorkflowTemplateApiV1WorkflowTemplatesDuplicatePostResponses, DuplicateWorkflowTemplateApiV1WorkflowTemplatesDuplicatePostErrors, ThrowOnError>({
    url: '/api/v1/workflow/templates/duplicate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get a presigned URL to upload a custom ambient noise audio file
 *
 * Generate a presigned PUT URL for uploading a custom ambient noise file.
 */
export const getAmbientNoiseUploadUrlApiV1WorkflowAmbientNoiseUploadUrlPost = <ThrowOnError extends boolean = false>(options: Options<GetAmbientNoiseUploadUrlApiV1WorkflowAmbientNoiseUploadUrlPostData, ThrowOnError>) => (options.client ?? client).post<GetAmbientNoiseUploadUrlApiV1WorkflowAmbientNoiseUploadUrlPostResponses, GetAmbientNoiseUploadUrlApiV1WorkflowAmbientNoiseUploadUrlPostErrors, ThrowOnError>({
    url: '/api/v1/workflow/ambient-noise/upload-url',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create Text Chat Session
 */
export const createTextChatSessionApiV1WorkflowWorkflowIdTextChatSessionsPost = <ThrowOnError extends boolean = false>(options: Options<CreateTextChatSessionApiV1WorkflowWorkflowIdTextChatSessionsPostData, ThrowOnError>) => (options.client ?? client).post<CreateTextChatSessionApiV1WorkflowWorkflowIdTextChatSessionsPostResponses, CreateTextChatSessionApiV1WorkflowWorkflowIdTextChatSessionsPostErrors, ThrowOnError>({
    url: '/api/v1/workflow/{workflow_id}/text-chat/sessions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Text Chat Session
 */
export const getTextChatSessionApiV1WorkflowWorkflowIdTextChatSessionsRunIdGet = <ThrowOnError extends boolean = false>(options: Options<GetTextChatSessionApiV1WorkflowWorkflowIdTextChatSessionsRunIdGetData, ThrowOnError>) => (options.client ?? client).get<GetTextChatSessionApiV1WorkflowWorkflowIdTextChatSessionsRunIdGetResponses, GetTextChatSessionApiV1WorkflowWorkflowIdTextChatSessionsRunIdGetErrors, ThrowOnError>({ url: '/api/v1/workflow/{workflow_id}/text-chat/sessions/{run_id}', ...options });

/**
 * Append Text Chat Message
 */
export const appendTextChatMessageApiV1WorkflowWorkflowIdTextChatSessionsRunIdMessagesPost = <ThrowOnError extends boolean = false>(options: Options<AppendTextChatMessageApiV1WorkflowWorkflowIdTextChatSessionsRunIdMessagesPostData, ThrowOnError>) => (options.client ?? client).post<AppendTextChatMessageApiV1WorkflowWorkflowIdTextChatSessionsRunIdMessagesPostResponses, AppendTextChatMessageApiV1WorkflowWorkflowIdTextChatSessionsRunIdMessagesPostErrors, ThrowOnError>({
    url: '/api/v1/workflow/{workflow_id}/text-chat/sessions/{run_id}/messages',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Rewind Text Chat Session
 */
export const rewindTextChatSessionApiV1WorkflowWorkflowIdTextChatSessionsRunIdRewindPost = <ThrowOnError extends boolean = false>(options: Options<RewindTextChatSessionApiV1WorkflowWorkflowIdTextChatSessionsRunIdRewindPostData, ThrowOnError>) => (options.client ?? client).post<RewindTextChatSessionApiV1WorkflowWorkflowIdTextChatSessionsRunIdRewindPostResponses, RewindTextChatSessionApiV1WorkflowWorkflowIdTextChatSessionsRunIdRewindPostErrors, ThrowOnError>({
    url: '/api/v1/workflow/{workflow_id}/text-chat/sessions/{run_id}/rewind',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Default Configurations
 */
export const getDefaultConfigurationsApiV1UserConfigurationsDefaultsGet = <ThrowOnError extends boolean = false>(options?: Options<GetDefaultConfigurationsApiV1UserConfigurationsDefaultsGetData, ThrowOnError>) => (options?.client ?? client).get<GetDefaultConfigurationsApiV1UserConfigurationsDefaultsGetResponses, GetDefaultConfigurationsApiV1UserConfigurationsDefaultsGetErrors, ThrowOnError>({ url: '/api/v1/user/configurations/defaults', ...options });

/**
 * Get Auth User
 */
export const getAuthUserApiV1UserAuthUserGet = <ThrowOnError extends boolean = false>(options?: Options<GetAuthUserApiV1UserAuthUserGetData, ThrowOnError>) => (options?.client ?? client).get<GetAuthUserApiV1UserAuthUserGetResponses, GetAuthUserApiV1UserAuthUserGetErrors, ThrowOnError>({ url: '/api/v1/user/auth/user', ...options });

/**
 * Get User Configurations
 */
export const getUserConfigurationsApiV1UserConfigurationsUserGet = <ThrowOnError extends boolean = false>(options?: Options<GetUserConfigurationsApiV1UserConfigurationsUserGetData, ThrowOnError>) => (options?.client ?? client).get<GetUserConfigurationsApiV1UserConfigurationsUserGetResponses, GetUserConfigurationsApiV1UserConfigurationsUserGetErrors, ThrowOnError>({ url: '/api/v1/user/configurations/user', ...options });

/**
 * Update User Configurations
 */
export const updateUserConfigurationsApiV1UserConfigurationsUserPut = <ThrowOnError extends boolean = false>(options: Options<UpdateUserConfigurationsApiV1UserConfigurationsUserPutData, ThrowOnError>) => (options.client ?? client).put<UpdateUserConfigurationsApiV1UserConfigurationsUserPutResponses, UpdateUserConfigurationsApiV1UserConfigurationsUserPutErrors, ThrowOnError>({
    url: '/api/v1/user/configurations/user',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Validate User Configurations
 */
export const validateUserConfigurationsApiV1UserConfigurationsUserValidateGet = <ThrowOnError extends boolean = false>(options?: Options<ValidateUserConfigurationsApiV1UserConfigurationsUserValidateGetData, ThrowOnError>) => (options?.client ?? client).get<ValidateUserConfigurationsApiV1UserConfigurationsUserValidateGetResponses, ValidateUserConfigurationsApiV1UserConfigurationsUserValidateGetErrors, ThrowOnError>({ url: '/api/v1/user/configurations/user/validate', ...options });

/**
 * Get Api Keys
 *
 * Get all API keys for the user's selected organization.
 */
export const getApiKeysApiV1UserApiKeysGet = <ThrowOnError extends boolean = false>(options?: Options<GetApiKeysApiV1UserApiKeysGetData, ThrowOnError>) => (options?.client ?? client).get<GetApiKeysApiV1UserApiKeysGetResponses, GetApiKeysApiV1UserApiKeysGetErrors, ThrowOnError>({ url: '/api/v1/user/api-keys', ...options });

/**
 * Create Api Key
 *
 * Create a new API key for the user's selected organization.
 */
export const createApiKeyApiV1UserApiKeysPost = <ThrowOnError extends boolean = false>(options: Options<CreateApiKeyApiV1UserApiKeysPostData, ThrowOnError>) => (options.client ?? client).post<CreateApiKeyApiV1UserApiKeysPostResponses, CreateApiKeyApiV1UserApiKeysPostErrors, ThrowOnError>({
    url: '/api/v1/user/api-keys',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Archive Api Key
 *
 * Archive an API key (soft delete).
 */
export const archiveApiKeyApiV1UserApiKeysApiKeyIdDelete = <ThrowOnError extends boolean = false>(options: Options<ArchiveApiKeyApiV1UserApiKeysApiKeyIdDeleteData, ThrowOnError>) => (options.client ?? client).delete<ArchiveApiKeyApiV1UserApiKeysApiKeyIdDeleteResponses, ArchiveApiKeyApiV1UserApiKeysApiKeyIdDeleteErrors, ThrowOnError>({ url: '/api/v1/user/api-keys/{api_key_id}', ...options });

/**
 * Reactivate Api Key
 *
 * Reactivate an archived API key.
 */
export const reactivateApiKeyApiV1UserApiKeysApiKeyIdReactivatePut = <ThrowOnError extends boolean = false>(options: Options<ReactivateApiKeyApiV1UserApiKeysApiKeyIdReactivatePutData, ThrowOnError>) => (options.client ?? client).put<ReactivateApiKeyApiV1UserApiKeysApiKeyIdReactivatePutResponses, ReactivateApiKeyApiV1UserApiKeysApiKeyIdReactivatePutErrors, ThrowOnError>({ url: '/api/v1/user/api-keys/{api_key_id}/reactivate', ...options });

/**
 * Get Voices
 *
 * Get available voices for a TTS provider.
 */
export const getVoicesApiV1UserConfigurationsVoicesProviderGet = <ThrowOnError extends boolean = false>(options: Options<GetVoicesApiV1UserConfigurationsVoicesProviderGetData, ThrowOnError>) => (options.client ?? client).get<GetVoicesApiV1UserConfigurationsVoicesProviderGetResponses, GetVoicesApiV1UserConfigurationsVoicesProviderGetErrors, ThrowOnError>({ url: '/api/v1/user/configurations/voices/{provider}', ...options });

/**
 * Create Campaign
 *
 * Create a new campaign
 */
export const createCampaignApiV1CampaignCreatePost = <ThrowOnError extends boolean = false>(options: Options<CreateCampaignApiV1CampaignCreatePostData, ThrowOnError>) => (options.client ?? client).post<CreateCampaignApiV1CampaignCreatePostResponses, CreateCampaignApiV1CampaignCreatePostErrors, ThrowOnError>({
    url: '/api/v1/campaign/create',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Campaigns
 *
 * Get campaigns for user's organization
 */
export const getCampaignsApiV1CampaignGet = <ThrowOnError extends boolean = false>(options?: Options<GetCampaignsApiV1CampaignGetData, ThrowOnError>) => (options?.client ?? client).get<GetCampaignsApiV1CampaignGetResponses, GetCampaignsApiV1CampaignGetErrors, ThrowOnError>({ url: '/api/v1/campaign/', ...options });

/**
 * Get Campaign
 *
 * Get campaign details
 */
export const getCampaignApiV1CampaignCampaignIdGet = <ThrowOnError extends boolean = false>(options: Options<GetCampaignApiV1CampaignCampaignIdGetData, ThrowOnError>) => (options.client ?? client).get<GetCampaignApiV1CampaignCampaignIdGetResponses, GetCampaignApiV1CampaignCampaignIdGetErrors, ThrowOnError>({ url: '/api/v1/campaign/{campaign_id}', ...options });

/**
 * Update Campaign
 *
 * Update campaign settings (name, retry config, max concurrency, schedule)
 */
export const updateCampaignApiV1CampaignCampaignIdPatch = <ThrowOnError extends boolean = false>(options: Options<UpdateCampaignApiV1CampaignCampaignIdPatchData, ThrowOnError>) => (options.client ?? client).patch<UpdateCampaignApiV1CampaignCampaignIdPatchResponses, UpdateCampaignApiV1CampaignCampaignIdPatchErrors, ThrowOnError>({
    url: '/api/v1/campaign/{campaign_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Start Campaign
 *
 * Start campaign execution
 */
export const startCampaignApiV1CampaignCampaignIdStartPost = <ThrowOnError extends boolean = false>(options: Options<StartCampaignApiV1CampaignCampaignIdStartPostData, ThrowOnError>) => (options.client ?? client).post<StartCampaignApiV1CampaignCampaignIdStartPostResponses, StartCampaignApiV1CampaignCampaignIdStartPostErrors, ThrowOnError>({ url: '/api/v1/campaign/{campaign_id}/start', ...options });

/**
 * Pause Campaign
 *
 * Pause campaign execution
 */
export const pauseCampaignApiV1CampaignCampaignIdPausePost = <ThrowOnError extends boolean = false>(options: Options<PauseCampaignApiV1CampaignCampaignIdPausePostData, ThrowOnError>) => (options.client ?? client).post<PauseCampaignApiV1CampaignCampaignIdPausePostResponses, PauseCampaignApiV1CampaignCampaignIdPausePostErrors, ThrowOnError>({ url: '/api/v1/campaign/{campaign_id}/pause', ...options });

/**
 * Get Campaign Runs
 *
 * Get campaign workflow runs with pagination, filters and sorting
 */
export const getCampaignRunsApiV1CampaignCampaignIdRunsGet = <ThrowOnError extends boolean = false>(options: Options<GetCampaignRunsApiV1CampaignCampaignIdRunsGetData, ThrowOnError>) => (options.client ?? client).get<GetCampaignRunsApiV1CampaignCampaignIdRunsGetResponses, GetCampaignRunsApiV1CampaignCampaignIdRunsGetErrors, ThrowOnError>({ url: '/api/v1/campaign/{campaign_id}/runs', ...options });

/**
 * Redial Campaign
 *
 * Create a new campaign that re-dials unique subscribers from a completed
 * campaign whose latest call resulted in voicemail, no-answer, or busy.
 *
 * The new campaign is created in 'created' state with queued_runs pre-seeded
 * from the parent's original initial contexts. A campaign can be redialed at
 * most once.
 */
export const redialCampaignApiV1CampaignCampaignIdRedialPost = <ThrowOnError extends boolean = false>(options: Options<RedialCampaignApiV1CampaignCampaignIdRedialPostData, ThrowOnError>) => (options.client ?? client).post<RedialCampaignApiV1CampaignCampaignIdRedialPostResponses, RedialCampaignApiV1CampaignCampaignIdRedialPostErrors, ThrowOnError>({
    url: '/api/v1/campaign/{campaign_id}/redial',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Resume Campaign
 *
 * Resume a paused campaign
 */
export const resumeCampaignApiV1CampaignCampaignIdResumePost = <ThrowOnError extends boolean = false>(options: Options<ResumeCampaignApiV1CampaignCampaignIdResumePostData, ThrowOnError>) => (options.client ?? client).post<ResumeCampaignApiV1CampaignCampaignIdResumePostResponses, ResumeCampaignApiV1CampaignCampaignIdResumePostErrors, ThrowOnError>({ url: '/api/v1/campaign/{campaign_id}/resume', ...options });

/**
 * Get Campaign Progress
 *
 * Get current campaign progress and statistics
 */
export const getCampaignProgressApiV1CampaignCampaignIdProgressGet = <ThrowOnError extends boolean = false>(options: Options<GetCampaignProgressApiV1CampaignCampaignIdProgressGetData, ThrowOnError>) => (options.client ?? client).get<GetCampaignProgressApiV1CampaignCampaignIdProgressGetResponses, GetCampaignProgressApiV1CampaignCampaignIdProgressGetErrors, ThrowOnError>({ url: '/api/v1/campaign/{campaign_id}/progress', ...options });

/**
 * Get Campaign Source Download Url
 *
 * Get presigned download URL for campaign CSV source file
 * Validates that the campaign belongs to the user's organization for security.
 */
export const getCampaignSourceDownloadUrlApiV1CampaignCampaignIdSourceDownloadUrlGet = <ThrowOnError extends boolean = false>(options: Options<GetCampaignSourceDownloadUrlApiV1CampaignCampaignIdSourceDownloadUrlGetData, ThrowOnError>) => (options.client ?? client).get<GetCampaignSourceDownloadUrlApiV1CampaignCampaignIdSourceDownloadUrlGetResponses, GetCampaignSourceDownloadUrlApiV1CampaignCampaignIdSourceDownloadUrlGetErrors, ThrowOnError>({ url: '/api/v1/campaign/{campaign_id}/source-download-url', ...options });

/**
 * Download Campaign Report
 *
 * Download a CSV report of completed campaign runs.
 */
export const downloadCampaignReportApiV1CampaignCampaignIdReportGet = <ThrowOnError extends boolean = false>(options: Options<DownloadCampaignReportApiV1CampaignCampaignIdReportGetData, ThrowOnError>) => (options.client ?? client).get<DownloadCampaignReportApiV1CampaignCampaignIdReportGetResponses, DownloadCampaignReportApiV1CampaignCampaignIdReportGetErrors, ThrowOnError>({ url: '/api/v1/campaign/{campaign_id}/report', ...options });

/**
 * List Credentials
 *
 * List all webhook credentials for the user's organization.
 *
 * Returns:
 * List of credentials (without sensitive data)
 */
export const listCredentialsApiV1CredentialsGet = <ThrowOnError extends boolean = false>(options?: Options<ListCredentialsApiV1CredentialsGetData, ThrowOnError>) => (options?.client ?? client).get<ListCredentialsApiV1CredentialsGetResponses, ListCredentialsApiV1CredentialsGetErrors, ThrowOnError>({ url: '/api/v1/credentials/', ...options });

/**
 * Create Credential
 *
 * Create a new webhook credential.
 *
 * Args:
 * request: The credential creation request
 *
 * Returns:
 * The created credential (without sensitive data)
 */
export const createCredentialApiV1CredentialsPost = <ThrowOnError extends boolean = false>(options: Options<CreateCredentialApiV1CredentialsPostData, ThrowOnError>) => (options.client ?? client).post<CreateCredentialApiV1CredentialsPostResponses, CreateCredentialApiV1CredentialsPostErrors, ThrowOnError>({
    url: '/api/v1/credentials/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Credential
 *
 * Delete (soft delete) a webhook credential.
 *
 * Args:
 * credential_uuid: The UUID of the credential to delete
 *
 * Returns:
 * Success message
 */
export const deleteCredentialApiV1CredentialsCredentialUuidDelete = <ThrowOnError extends boolean = false>(options: Options<DeleteCredentialApiV1CredentialsCredentialUuidDeleteData, ThrowOnError>) => (options.client ?? client).delete<DeleteCredentialApiV1CredentialsCredentialUuidDeleteResponses, DeleteCredentialApiV1CredentialsCredentialUuidDeleteErrors, ThrowOnError>({ url: '/api/v1/credentials/{credential_uuid}', ...options });

/**
 * Get Credential
 *
 * Get a specific webhook credential by UUID.
 *
 * Args:
 * credential_uuid: The UUID of the credential
 *
 * Returns:
 * The credential (without sensitive data)
 */
export const getCredentialApiV1CredentialsCredentialUuidGet = <ThrowOnError extends boolean = false>(options: Options<GetCredentialApiV1CredentialsCredentialUuidGetData, ThrowOnError>) => (options.client ?? client).get<GetCredentialApiV1CredentialsCredentialUuidGetResponses, GetCredentialApiV1CredentialsCredentialUuidGetErrors, ThrowOnError>({ url: '/api/v1/credentials/{credential_uuid}', ...options });

/**
 * Update Credential
 *
 * Update a webhook credential.
 *
 * Args:
 * credential_uuid: The UUID of the credential to update
 * request: The update request
 *
 * Returns:
 * The updated credential (without sensitive data)
 */
export const updateCredentialApiV1CredentialsCredentialUuidPut = <ThrowOnError extends boolean = false>(options: Options<UpdateCredentialApiV1CredentialsCredentialUuidPutData, ThrowOnError>) => (options.client ?? client).put<UpdateCredentialApiV1CredentialsCredentialUuidPutResponses, UpdateCredentialApiV1CredentialsCredentialUuidPutErrors, ThrowOnError>({
    url: '/api/v1/credentials/{credential_uuid}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Tools
 *
 * List all tools for the user's organization.
 *
 * Args:
 * status: Optional filter by status (active, archived, draft)
 * category: Optional filter by category (http_api, native, integration)
 *
 * Returns:
 * List of tools
 */
export const listToolsApiV1ToolsGet = <ThrowOnError extends boolean = false>(options?: Options<ListToolsApiV1ToolsGetData, ThrowOnError>) => (options?.client ?? client).get<ListToolsApiV1ToolsGetResponses, ListToolsApiV1ToolsGetErrors, ThrowOnError>({ url: '/api/v1/tools/', ...options });

/**
 * Create Tool
 *
 * Create a new tool.
 *
 * Args:
 * request: The tool creation request
 *
 * Returns:
 * The created tool
 */
export const createToolApiV1ToolsPost = <ThrowOnError extends boolean = false>(options: Options<CreateToolApiV1ToolsPostData, ThrowOnError>) => (options.client ?? client).post<CreateToolApiV1ToolsPostResponses, CreateToolApiV1ToolsPostErrors, ThrowOnError>({
    url: '/api/v1/tools/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Tool
 *
 * Archive (soft delete) a tool.
 *
 * Args:
 * tool_uuid: The UUID of the tool to delete
 *
 * Returns:
 * Success message
 */
export const deleteToolApiV1ToolsToolUuidDelete = <ThrowOnError extends boolean = false>(options: Options<DeleteToolApiV1ToolsToolUuidDeleteData, ThrowOnError>) => (options.client ?? client).delete<DeleteToolApiV1ToolsToolUuidDeleteResponses, DeleteToolApiV1ToolsToolUuidDeleteErrors, ThrowOnError>({ url: '/api/v1/tools/{tool_uuid}', ...options });

/**
 * Get Tool
 *
 * Get a specific tool by UUID.
 *
 * Args:
 * tool_uuid: The UUID of the tool
 *
 * Returns:
 * The tool
 */
export const getToolApiV1ToolsToolUuidGet = <ThrowOnError extends boolean = false>(options: Options<GetToolApiV1ToolsToolUuidGetData, ThrowOnError>) => (options.client ?? client).get<GetToolApiV1ToolsToolUuidGetResponses, GetToolApiV1ToolsToolUuidGetErrors, ThrowOnError>({ url: '/api/v1/tools/{tool_uuid}', ...options });

/**
 * Update Tool
 *
 * Update a tool.
 *
 * Args:
 * tool_uuid: The UUID of the tool to update
 * request: The update request
 *
 * Returns:
 * The updated tool
 */
export const updateToolApiV1ToolsToolUuidPut = <ThrowOnError extends boolean = false>(options: Options<UpdateToolApiV1ToolsToolUuidPutData, ThrowOnError>) => (options.client ?? client).put<UpdateToolApiV1ToolsToolUuidPutResponses, UpdateToolApiV1ToolsToolUuidPutErrors, ThrowOnError>({
    url: '/api/v1/tools/{tool_uuid}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Refresh Mcp Tools
 *
 * Re-discover an MCP tool's server catalog and overwrite the cached
 * ``definition.config.discovered_tools``. Server down → 200 with error
 * (cache not overwritten on transient failure).
 */
export const refreshMcpToolsApiV1ToolsToolUuidMcpRefreshPost = <ThrowOnError extends boolean = false>(options: Options<RefreshMcpToolsApiV1ToolsToolUuidMcpRefreshPostData, ThrowOnError>) => (options.client ?? client).post<RefreshMcpToolsApiV1ToolsToolUuidMcpRefreshPostResponses, RefreshMcpToolsApiV1ToolsToolUuidMcpRefreshPostErrors, ThrowOnError>({ url: '/api/v1/tools/{tool_uuid}/mcp/refresh', ...options });

/**
 * Unarchive Tool
 *
 * Unarchive a tool (restore from archived state).
 *
 * Args:
 * tool_uuid: The UUID of the tool to unarchive
 *
 * Returns:
 * The unarchived tool
 */
export const unarchiveToolApiV1ToolsToolUuidUnarchivePost = <ThrowOnError extends boolean = false>(options: Options<UnarchiveToolApiV1ToolsToolUuidUnarchivePostData, ThrowOnError>) => (options.client ?? client).post<UnarchiveToolApiV1ToolsToolUuidUnarchivePostResponses, UnarchiveToolApiV1ToolsToolUuidUnarchivePostErrors, ThrowOnError>({ url: '/api/v1/tools/{tool_uuid}/unarchive', ...options });

/**
 * Get Telephony Providers Metadata
 *
 * Return the list of available telephony providers and their form schemas.
 *
 * The UI uses this to render the configuration form generically instead of
 * hard-coding fields per provider. Adding a new provider only requires
 * declaring its ui_metadata in providers/<name>/__init__.py.
 */
export const getTelephonyProvidersMetadataApiV1OrganizationsTelephonyProvidersMetadataGet = <ThrowOnError extends boolean = false>(options?: Options<GetTelephonyProvidersMetadataApiV1OrganizationsTelephonyProvidersMetadataGetData, ThrowOnError>) => (options?.client ?? client).get<GetTelephonyProvidersMetadataApiV1OrganizationsTelephonyProvidersMetadataGetResponses, GetTelephonyProvidersMetadataApiV1OrganizationsTelephonyProvidersMetadataGetErrors, ThrowOnError>({ url: '/api/v1/organizations/telephony-providers/metadata', ...options });

/**
 * Get Telephony Config Warnings
 *
 * Return aggregated warning counts for the current org's telephony configs.
 *
 * Today this surfaces only Telnyx configs missing ``webhook_public_key``;
 * additional warning types should be added as new fields on the response.
 */
export const getTelephonyConfigWarningsApiV1OrganizationsTelephonyConfigWarningsGet = <ThrowOnError extends boolean = false>(options?: Options<GetTelephonyConfigWarningsApiV1OrganizationsTelephonyConfigWarningsGetData, ThrowOnError>) => (options?.client ?? client).get<GetTelephonyConfigWarningsApiV1OrganizationsTelephonyConfigWarningsGetResponses, GetTelephonyConfigWarningsApiV1OrganizationsTelephonyConfigWarningsGetErrors, ThrowOnError>({ url: '/api/v1/organizations/telephony-config-warnings', ...options });

/**
 * List Telephony Configurations
 *
 * List the org's telephony configurations with phone-number counts.
 */
export const listTelephonyConfigurationsApiV1OrganizationsTelephonyConfigsGet = <ThrowOnError extends boolean = false>(options?: Options<ListTelephonyConfigurationsApiV1OrganizationsTelephonyConfigsGetData, ThrowOnError>) => (options?.client ?? client).get<ListTelephonyConfigurationsApiV1OrganizationsTelephonyConfigsGetResponses, ListTelephonyConfigurationsApiV1OrganizationsTelephonyConfigsGetErrors, ThrowOnError>({ url: '/api/v1/organizations/telephony-configs', ...options });

/**
 * Create Telephony Configuration
 *
 * Create a new telephony configuration for the org.
 */
export const createTelephonyConfigurationApiV1OrganizationsTelephonyConfigsPost = <ThrowOnError extends boolean = false>(options: Options<CreateTelephonyConfigurationApiV1OrganizationsTelephonyConfigsPostData, ThrowOnError>) => (options.client ?? client).post<CreateTelephonyConfigurationApiV1OrganizationsTelephonyConfigsPostResponses, CreateTelephonyConfigurationApiV1OrganizationsTelephonyConfigsPostErrors, ThrowOnError>({
    url: '/api/v1/organizations/telephony-configs',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Telephony Configuration
 */
export const deleteTelephonyConfigurationApiV1OrganizationsTelephonyConfigsConfigIdDelete = <ThrowOnError extends boolean = false>(options: Options<DeleteTelephonyConfigurationApiV1OrganizationsTelephonyConfigsConfigIdDeleteData, ThrowOnError>) => (options.client ?? client).delete<DeleteTelephonyConfigurationApiV1OrganizationsTelephonyConfigsConfigIdDeleteResponses, DeleteTelephonyConfigurationApiV1OrganizationsTelephonyConfigsConfigIdDeleteErrors, ThrowOnError>({ url: '/api/v1/organizations/telephony-configs/{config_id}', ...options });

/**
 * Get Telephony Configuration By Id
 */
export const getTelephonyConfigurationByIdApiV1OrganizationsTelephonyConfigsConfigIdGet = <ThrowOnError extends boolean = false>(options: Options<GetTelephonyConfigurationByIdApiV1OrganizationsTelephonyConfigsConfigIdGetData, ThrowOnError>) => (options.client ?? client).get<GetTelephonyConfigurationByIdApiV1OrganizationsTelephonyConfigsConfigIdGetResponses, GetTelephonyConfigurationByIdApiV1OrganizationsTelephonyConfigsConfigIdGetErrors, ThrowOnError>({ url: '/api/v1/organizations/telephony-configs/{config_id}', ...options });

/**
 * Update Telephony Configuration
 */
export const updateTelephonyConfigurationApiV1OrganizationsTelephonyConfigsConfigIdPut = <ThrowOnError extends boolean = false>(options: Options<UpdateTelephonyConfigurationApiV1OrganizationsTelephonyConfigsConfigIdPutData, ThrowOnError>) => (options.client ?? client).put<UpdateTelephonyConfigurationApiV1OrganizationsTelephonyConfigsConfigIdPutResponses, UpdateTelephonyConfigurationApiV1OrganizationsTelephonyConfigsConfigIdPutErrors, ThrowOnError>({
    url: '/api/v1/organizations/telephony-configs/{config_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Set Default Outbound
 */
export const setDefaultOutboundApiV1OrganizationsTelephonyConfigsConfigIdSetDefaultOutboundPost = <ThrowOnError extends boolean = false>(options: Options<SetDefaultOutboundApiV1OrganizationsTelephonyConfigsConfigIdSetDefaultOutboundPostData, ThrowOnError>) => (options.client ?? client).post<SetDefaultOutboundApiV1OrganizationsTelephonyConfigsConfigIdSetDefaultOutboundPostResponses, SetDefaultOutboundApiV1OrganizationsTelephonyConfigsConfigIdSetDefaultOutboundPostErrors, ThrowOnError>({ url: '/api/v1/organizations/telephony-configs/{config_id}/set-default-outbound', ...options });

/**
 * List Phone Numbers
 */
export const listPhoneNumbersApiV1OrganizationsTelephonyConfigsConfigIdPhoneNumbersGet = <ThrowOnError extends boolean = false>(options: Options<ListPhoneNumbersApiV1OrganizationsTelephonyConfigsConfigIdPhoneNumbersGetData, ThrowOnError>) => (options.client ?? client).get<ListPhoneNumbersApiV1OrganizationsTelephonyConfigsConfigIdPhoneNumbersGetResponses, ListPhoneNumbersApiV1OrganizationsTelephonyConfigsConfigIdPhoneNumbersGetErrors, ThrowOnError>({ url: '/api/v1/organizations/telephony-configs/{config_id}/phone-numbers', ...options });

/**
 * Create Phone Number
 */
export const createPhoneNumberApiV1OrganizationsTelephonyConfigsConfigIdPhoneNumbersPost = <ThrowOnError extends boolean = false>(options: Options<CreatePhoneNumberApiV1OrganizationsTelephonyConfigsConfigIdPhoneNumbersPostData, ThrowOnError>) => (options.client ?? client).post<CreatePhoneNumberApiV1OrganizationsTelephonyConfigsConfigIdPhoneNumbersPostResponses, CreatePhoneNumberApiV1OrganizationsTelephonyConfigsConfigIdPhoneNumbersPostErrors, ThrowOnError>({
    url: '/api/v1/organizations/telephony-configs/{config_id}/phone-numbers',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Phone Number
 */
export const deletePhoneNumberApiV1OrganizationsTelephonyConfigsConfigIdPhoneNumbersPhoneNumberIdDelete = <ThrowOnError extends boolean = false>(options: Options<DeletePhoneNumberApiV1OrganizationsTelephonyConfigsConfigIdPhoneNumbersPhoneNumberIdDeleteData, ThrowOnError>) => (options.client ?? client).delete<DeletePhoneNumberApiV1OrganizationsTelephonyConfigsConfigIdPhoneNumbersPhoneNumberIdDeleteResponses, DeletePhoneNumberApiV1OrganizationsTelephonyConfigsConfigIdPhoneNumbersPhoneNumberIdDeleteErrors, ThrowOnError>({ url: '/api/v1/organizations/telephony-configs/{config_id}/phone-numbers/{phone_number_id}', ...options });

/**
 * Get Phone Number
 */
export const getPhoneNumberApiV1OrganizationsTelephonyConfigsConfigIdPhoneNumbersPhoneNumberIdGet = <ThrowOnError extends boolean = false>(options: Options<GetPhoneNumberApiV1OrganizationsTelephonyConfigsConfigIdPhoneNumbersPhoneNumberIdGetData, ThrowOnError>) => (options.client ?? client).get<GetPhoneNumberApiV1OrganizationsTelephonyConfigsConfigIdPhoneNumbersPhoneNumberIdGetResponses, GetPhoneNumberApiV1OrganizationsTelephonyConfigsConfigIdPhoneNumbersPhoneNumberIdGetErrors, ThrowOnError>({ url: '/api/v1/organizations/telephony-configs/{config_id}/phone-numbers/{phone_number_id}', ...options });

/**
 * Update Phone Number
 */
export const updatePhoneNumberApiV1OrganizationsTelephonyConfigsConfigIdPhoneNumbersPhoneNumberIdPut = <ThrowOnError extends boolean = false>(options: Options<UpdatePhoneNumberApiV1OrganizationsTelephonyConfigsConfigIdPhoneNumbersPhoneNumberIdPutData, ThrowOnError>) => (options.client ?? client).put<UpdatePhoneNumberApiV1OrganizationsTelephonyConfigsConfigIdPhoneNumbersPhoneNumberIdPutResponses, UpdatePhoneNumberApiV1OrganizationsTelephonyConfigsConfigIdPhoneNumbersPhoneNumberIdPutErrors, ThrowOnError>({
    url: '/api/v1/organizations/telephony-configs/{config_id}/phone-numbers/{phone_number_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Set Default Caller Id
 */
export const setDefaultCallerIdApiV1OrganizationsTelephonyConfigsConfigIdPhoneNumbersPhoneNumberIdSetDefaultCallerPost = <ThrowOnError extends boolean = false>(options: Options<SetDefaultCallerIdApiV1OrganizationsTelephonyConfigsConfigIdPhoneNumbersPhoneNumberIdSetDefaultCallerPostData, ThrowOnError>) => (options.client ?? client).post<SetDefaultCallerIdApiV1OrganizationsTelephonyConfigsConfigIdPhoneNumbersPhoneNumberIdSetDefaultCallerPostResponses, SetDefaultCallerIdApiV1OrganizationsTelephonyConfigsConfigIdPhoneNumbersPhoneNumberIdSetDefaultCallerPostErrors, ThrowOnError>({ url: '/api/v1/organizations/telephony-configs/{config_id}/phone-numbers/{phone_number_id}/set-default-caller', ...options });

/**
 * Get Telephony Configuration
 *
 * Legacy: returns the org's default config in the original per-provider
 * response shape so the existing single-form UI keeps working. Prefer the
 * multi-config endpoints (``/telephony-configs``) for new clients.
 */
export const getTelephonyConfigurationApiV1OrganizationsTelephonyConfigGet = <ThrowOnError extends boolean = false>(options?: Options<GetTelephonyConfigurationApiV1OrganizationsTelephonyConfigGetData, ThrowOnError>) => (options?.client ?? client).get<GetTelephonyConfigurationApiV1OrganizationsTelephonyConfigGetResponses, GetTelephonyConfigurationApiV1OrganizationsTelephonyConfigGetErrors, ThrowOnError>({ url: '/api/v1/organizations/telephony-config', ...options });

/**
 * Save Telephony Configuration
 *
 * Legacy: upserts the org's default config (and its phone numbers) in the
 * original payload shape so existing UI clients keep working. Prefer the
 * multi-config + phone-number endpoints for new clients.
 */
export const saveTelephonyConfigurationApiV1OrganizationsTelephonyConfigPost = <ThrowOnError extends boolean = false>(options: Options<SaveTelephonyConfigurationApiV1OrganizationsTelephonyConfigPostData, ThrowOnError>) => (options.client ?? client).post<SaveTelephonyConfigurationApiV1OrganizationsTelephonyConfigPostResponses, SaveTelephonyConfigurationApiV1OrganizationsTelephonyConfigPostErrors, ThrowOnError>({
    url: '/api/v1/organizations/telephony-config',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Langfuse Credentials
 *
 * Delete Langfuse credentials for the user's organization.
 */
export const deleteLangfuseCredentialsApiV1OrganizationsLangfuseCredentialsDelete = <ThrowOnError extends boolean = false>(options?: Options<DeleteLangfuseCredentialsApiV1OrganizationsLangfuseCredentialsDeleteData, ThrowOnError>) => (options?.client ?? client).delete<DeleteLangfuseCredentialsApiV1OrganizationsLangfuseCredentialsDeleteResponses, DeleteLangfuseCredentialsApiV1OrganizationsLangfuseCredentialsDeleteErrors, ThrowOnError>({ url: '/api/v1/organizations/langfuse-credentials', ...options });

/**
 * Get Langfuse Credentials
 *
 * Get Langfuse credentials for the user's organization with masked sensitive fields.
 */
export const getLangfuseCredentialsApiV1OrganizationsLangfuseCredentialsGet = <ThrowOnError extends boolean = false>(options?: Options<GetLangfuseCredentialsApiV1OrganizationsLangfuseCredentialsGetData, ThrowOnError>) => (options?.client ?? client).get<GetLangfuseCredentialsApiV1OrganizationsLangfuseCredentialsGetResponses, GetLangfuseCredentialsApiV1OrganizationsLangfuseCredentialsGetErrors, ThrowOnError>({ url: '/api/v1/organizations/langfuse-credentials', ...options });

/**
 * Save Langfuse Credentials
 *
 * Save Langfuse credentials for the user's organization.
 */
export const saveLangfuseCredentialsApiV1OrganizationsLangfuseCredentialsPost = <ThrowOnError extends boolean = false>(options: Options<SaveLangfuseCredentialsApiV1OrganizationsLangfuseCredentialsPostData, ThrowOnError>) => (options.client ?? client).post<SaveLangfuseCredentialsApiV1OrganizationsLangfuseCredentialsPostResponses, SaveLangfuseCredentialsApiV1OrganizationsLangfuseCredentialsPostErrors, ThrowOnError>({
    url: '/api/v1/organizations/langfuse-credentials',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Campaign Defaults
 *
 * Get campaign limits for the user's organization.
 *
 * Returns the organization's concurrent call limit and default retry configuration.
 */
export const getCampaignDefaultsApiV1OrganizationsCampaignDefaultsGet = <ThrowOnError extends boolean = false>(options?: Options<GetCampaignDefaultsApiV1OrganizationsCampaignDefaultsGetData, ThrowOnError>) => (options?.client ?? client).get<GetCampaignDefaultsApiV1OrganizationsCampaignDefaultsGetResponses, GetCampaignDefaultsApiV1OrganizationsCampaignDefaultsGetErrors, ThrowOnError>({ url: '/api/v1/organizations/campaign-defaults', ...options });

/**
 * Generate a signed S3 URL
 *
 * Return a short-lived signed URL for a file stored on S3 / MinIO.
 *
 * Access Control:
 * * Keys that embed an organization ID (``{prefix}/{org_id}/...``) are
 * authorized by matching the org_id against the requesting user's
 * organization.
 * * Legacy keys (``recordings/{run_id}.wav``, ``transcripts/{run_id}.txt``)
 * are authorized via the workflow run they belong to.
 * * Superusers can request any key.
 */
export const getSignedUrlApiV1S3SignedUrlGet = <ThrowOnError extends boolean = false>(options: Options<GetSignedUrlApiV1S3SignedUrlGetData, ThrowOnError>) => (options.client ?? client).get<GetSignedUrlApiV1S3SignedUrlGetResponses, GetSignedUrlApiV1S3SignedUrlGetErrors, ThrowOnError>({ url: '/api/v1/s3/signed-url', ...options });

/**
 * Get file metadata for debugging
 *
 * Get file metadata including creation timestamp for debugging.
 *
 * Access Control:
 * * Superusers can request any key.
 * * Regular users can only request resources belonging to **their** workflow runs.
 */
export const getFileMetadataApiV1S3FileMetadataGet = <ThrowOnError extends boolean = false>(options: Options<GetFileMetadataApiV1S3FileMetadataGetData, ThrowOnError>) => (options.client ?? client).get<GetFileMetadataApiV1S3FileMetadataGetResponses, GetFileMetadataApiV1S3FileMetadataGetErrors, ThrowOnError>({ url: '/api/v1/s3/file-metadata', ...options });

/**
 * Generate a presigned URL for direct CSV upload
 *
 * Generate a presigned PUT URL for direct CSV file upload to S3/MinIO.
 *
 * This endpoint enables browser-to-storage uploads without passing through the backend
 *
 * Access Control:
 * * All authenticated users can upload CSV files scoped to their organization.
 * * Files are stored with organization-scoped keys for multi-tenancy.
 *
 * Returns:
 * * upload_url: Presigned URL (valid for 15 minutes) for PUT request
 * * file_key: Unique storage key to use as source_id in campaign creation
 * * expires_in: URL expiration time in seconds
 */
export const getPresignedUploadUrlApiV1S3PresignedUploadUrlPost = <ThrowOnError extends boolean = false>(options: Options<GetPresignedUploadUrlApiV1S3PresignedUploadUrlPostData, ThrowOnError>) => (options.client ?? client).post<GetPresignedUploadUrlApiV1S3PresignedUploadUrlPostResponses, GetPresignedUploadUrlApiV1S3PresignedUploadUrlPostErrors, ThrowOnError>({
    url: '/api/v1/s3/presigned-upload-url',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Service Keys
 *
 * Get all service keys for the user's organization.
 */
export const getServiceKeysApiV1UserServiceKeysGet = <ThrowOnError extends boolean = false>(options?: Options<GetServiceKeysApiV1UserServiceKeysGetData, ThrowOnError>) => (options?.client ?? client).get<GetServiceKeysApiV1UserServiceKeysGetResponses, GetServiceKeysApiV1UserServiceKeysGetErrors, ThrowOnError>({ url: '/api/v1/user/service-keys', ...options });

/**
 * Create Service Key
 *
 * Create a new service key for the user's organization.
 */
export const createServiceKeyApiV1UserServiceKeysPost = <ThrowOnError extends boolean = false>(options: Options<CreateServiceKeyApiV1UserServiceKeysPostData, ThrowOnError>) => (options.client ?? client).post<CreateServiceKeyApiV1UserServiceKeysPostResponses, CreateServiceKeyApiV1UserServiceKeysPostErrors, ThrowOnError>({
    url: '/api/v1/user/service-keys',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Archive Service Key
 *
 * Archive a service key.
 */
export const archiveServiceKeyApiV1UserServiceKeysServiceKeyIdDelete = <ThrowOnError extends boolean = false>(options: Options<ArchiveServiceKeyApiV1UserServiceKeysServiceKeyIdDeleteData, ThrowOnError>) => (options.client ?? client).delete<ArchiveServiceKeyApiV1UserServiceKeysServiceKeyIdDeleteResponses, ArchiveServiceKeyApiV1UserServiceKeysServiceKeyIdDeleteErrors, ThrowOnError>({ url: '/api/v1/user/service-keys/{service_key_id}', ...options });

/**
 * Reactivate Service Key
 *
 * Reactivate an archived service key.
 *
 * Note: This endpoint is provided for API compatibility but service key
 * reactivation is not supported by MPS. Once archived, a service key
 * cannot be reactivated and a new key must be created instead.
 */
export const reactivateServiceKeyApiV1UserServiceKeysServiceKeyIdReactivatePut = <ThrowOnError extends boolean = false>(options: Options<ReactivateServiceKeyApiV1UserServiceKeysServiceKeyIdReactivatePutData, ThrowOnError>) => (options.client ?? client).put<ReactivateServiceKeyApiV1UserServiceKeysServiceKeyIdReactivatePutResponses, ReactivateServiceKeyApiV1UserServiceKeysServiceKeyIdReactivatePutErrors, ThrowOnError>({ url: '/api/v1/user/service-keys/{service_key_id}/reactivate', ...options });

/**
 * Get Current Period Usage
 *
 * Get current billing period usage for the user's organization.
 */
export const getCurrentPeriodUsageApiV1OrganizationsUsageCurrentPeriodGet = <ThrowOnError extends boolean = false>(options?: Options<GetCurrentPeriodUsageApiV1OrganizationsUsageCurrentPeriodGetData, ThrowOnError>) => (options?.client ?? client).get<GetCurrentPeriodUsageApiV1OrganizationsUsageCurrentPeriodGetResponses, GetCurrentPeriodUsageApiV1OrganizationsUsageCurrentPeriodGetErrors, ThrowOnError>({ url: '/api/v1/organizations/usage/current-period', ...options });

/**
 * Get Mps Credits
 *
 * Get aggregated usage and quota from MPS.
 *
 * OSS users: queries by provider_id (created_by).
 * Hosted users: queries by organization_id.
 */
export const getMpsCreditsApiV1OrganizationsUsageMpsCreditsGet = <ThrowOnError extends boolean = false>(options?: Options<GetMpsCreditsApiV1OrganizationsUsageMpsCreditsGetData, ThrowOnError>) => (options?.client ?? client).get<GetMpsCreditsApiV1OrganizationsUsageMpsCreditsGetResponses, GetMpsCreditsApiV1OrganizationsUsageMpsCreditsGetErrors, ThrowOnError>({ url: '/api/v1/organizations/usage/mps-credits', ...options });

/**
 * Get Usage History
 *
 * Get paginated workflow runs with usage for the organization.
 */
export const getUsageHistoryApiV1OrganizationsUsageRunsGet = <ThrowOnError extends boolean = false>(options?: Options<GetUsageHistoryApiV1OrganizationsUsageRunsGetData, ThrowOnError>) => (options?.client ?? client).get<GetUsageHistoryApiV1OrganizationsUsageRunsGetResponses, GetUsageHistoryApiV1OrganizationsUsageRunsGetErrors, ThrowOnError>({ url: '/api/v1/organizations/usage/runs', ...options });

/**
 * Download Usage Runs Report
 *
 * Download a CSV of runs matching the same filters as `/usage/runs`.
 */
export const downloadUsageRunsReportApiV1OrganizationsUsageRunsReportGet = <ThrowOnError extends boolean = false>(options?: Options<DownloadUsageRunsReportApiV1OrganizationsUsageRunsReportGetData, ThrowOnError>) => (options?.client ?? client).get<DownloadUsageRunsReportApiV1OrganizationsUsageRunsReportGetResponses, DownloadUsageRunsReportApiV1OrganizationsUsageRunsReportGetErrors, ThrowOnError>({ url: '/api/v1/organizations/usage/runs/report', ...options });

/**
 * Get Daily Usage Breakdown
 *
 * Get daily usage breakdown for the last N days. Only available for organizations with pricing.
 */
export const getDailyUsageBreakdownApiV1OrganizationsUsageDailyBreakdownGet = <ThrowOnError extends boolean = false>(options?: Options<GetDailyUsageBreakdownApiV1OrganizationsUsageDailyBreakdownGetData, ThrowOnError>) => (options?.client ?? client).get<GetDailyUsageBreakdownApiV1OrganizationsUsageDailyBreakdownGetResponses, GetDailyUsageBreakdownApiV1OrganizationsUsageDailyBreakdownGetErrors, ThrowOnError>({ url: '/api/v1/organizations/usage/daily-breakdown', ...options });

/**
 * Get Daily Report
 *
 * Get daily report for the specified date and timezone.
 * If workflow_id is provided, filters results to that specific workflow.
 * If workflow_id is None, includes all workflows for the organization.
 */
export const getDailyReportApiV1OrganizationsReportsDailyGet = <ThrowOnError extends boolean = false>(options: Options<GetDailyReportApiV1OrganizationsReportsDailyGetData, ThrowOnError>) => (options.client ?? client).get<GetDailyReportApiV1OrganizationsReportsDailyGetResponses, GetDailyReportApiV1OrganizationsReportsDailyGetErrors, ThrowOnError>({ url: '/api/v1/organizations/reports/daily', ...options });

/**
 * Get Workflow Options
 *
 * Get all workflows for the user's organization.
 * Used to populate the workflow selector dropdown in the reports page.
 */
export const getWorkflowOptionsApiV1OrganizationsReportsWorkflowsGet = <ThrowOnError extends boolean = false>(options?: Options<GetWorkflowOptionsApiV1OrganizationsReportsWorkflowsGetData, ThrowOnError>) => (options?.client ?? client).get<GetWorkflowOptionsApiV1OrganizationsReportsWorkflowsGetResponses, GetWorkflowOptionsApiV1OrganizationsReportsWorkflowsGetErrors, ThrowOnError>({ url: '/api/v1/organizations/reports/workflows', ...options });

/**
 * Get Daily Runs Detail
 *
 * Get detailed workflow runs for the specified date.
 * Used for CSV export functionality.
 */
export const getDailyRunsDetailApiV1OrganizationsReportsDailyRunsGet = <ThrowOnError extends boolean = false>(options: Options<GetDailyRunsDetailApiV1OrganizationsReportsDailyRunsGetData, ThrowOnError>) => (options.client ?? client).get<GetDailyRunsDetailApiV1OrganizationsReportsDailyRunsGetResponses, GetDailyRunsDetailApiV1OrganizationsReportsDailyRunsGetErrors, ThrowOnError>({ url: '/api/v1/organizations/reports/daily/runs', ...options });

/**
 * Get Turn Credentials
 *
 * Get time-limited TURN credentials for WebRTC connections.
 *
 * This endpoint generates ephemeral TURN credentials that are:
 * - Valid for the configured TTL (default: 24 hours)
 * - Cryptographically bound to the user via HMAC
 * - Compatible with coturn's use-auth-secret mode
 *
 * Returns:
 * TurnCredentialsResponse with username, password, ttl, and TURN URIs
 */
export const getTurnCredentialsApiV1TurnCredentialsGet = <ThrowOnError extends boolean = false>(options?: Options<GetTurnCredentialsApiV1TurnCredentialsGetData, ThrowOnError>) => (options?.client ?? client).get<GetTurnCredentialsApiV1TurnCredentialsGetResponses, GetTurnCredentialsApiV1TurnCredentialsGetErrors, ThrowOnError>({ url: '/api/v1/turn/credentials', ...options });

/**
 * Options Init
 *
 * Handle CORS preflight for init endpoint
 */
export const optionsInitApiV1PublicEmbedInitOptions = <ThrowOnError extends boolean = false>(options?: Options<OptionsInitApiV1PublicEmbedInitOptionsData, ThrowOnError>) => (options?.client ?? client).options<OptionsInitApiV1PublicEmbedInitOptionsResponses, OptionsInitApiV1PublicEmbedInitOptionsErrors, ThrowOnError>({ url: '/api/v1/public/embed/init', ...options });

/**
 * Initialize Embed Session
 *
 * Initialize an embed session with token validation and domain checking.
 *
 * This endpoint:
 * 1. Validates the embed token
 * 2. Checks domain whitelist
 * 3. Creates a workflow run
 * 4. Generates a temporary session token
 * 5. Returns configuration for the widget
 */
export const initializeEmbedSessionApiV1PublicEmbedInitPost = <ThrowOnError extends boolean = false>(options: Options<InitializeEmbedSessionApiV1PublicEmbedInitPostData, ThrowOnError>) => (options.client ?? client).post<InitializeEmbedSessionApiV1PublicEmbedInitPostResponses, InitializeEmbedSessionApiV1PublicEmbedInitPostErrors, ThrowOnError>({
    url: '/api/v1/public/embed/init',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Embed Config
 *
 * Get embed configuration without creating a session.
 *
 * This endpoint is used to fetch widget configuration for display purposes
 * without actually starting a call session.
 */
export const getEmbedConfigApiV1PublicEmbedConfigTokenGet = <ThrowOnError extends boolean = false>(options: Options<GetEmbedConfigApiV1PublicEmbedConfigTokenGetData, ThrowOnError>) => (options.client ?? client).get<GetEmbedConfigApiV1PublicEmbedConfigTokenGetResponses, GetEmbedConfigApiV1PublicEmbedConfigTokenGetErrors, ThrowOnError>({ url: '/api/v1/public/embed/config/{token}', ...options });

/**
 * Options Config
 *
 * Handle CORS preflight for config endpoint
 */
export const optionsConfigApiV1PublicEmbedConfigTokenOptions = <ThrowOnError extends boolean = false>(options: Options<OptionsConfigApiV1PublicEmbedConfigTokenOptionsData, ThrowOnError>) => (options.client ?? client).options<OptionsConfigApiV1PublicEmbedConfigTokenOptionsResponses, OptionsConfigApiV1PublicEmbedConfigTokenOptionsErrors, ThrowOnError>({ url: '/api/v1/public/embed/config/{token}', ...options });

/**
 * Get Public Turn Credentials
 *
 * Get TURN credentials for an embed session.
 *
 * This endpoint allows embedded widgets to obtain TURN server credentials
 * for WebRTC connections without requiring authentication.
 *
 * Args:
 * session_token: The session token from embed initialization
 *
 * Returns:
 * TurnCredentialsResponse with username, password, ttl, and TURN URIs
 */
export const getPublicTurnCredentialsApiV1PublicEmbedTurnCredentialsSessionTokenGet = <ThrowOnError extends boolean = false>(options: Options<GetPublicTurnCredentialsApiV1PublicEmbedTurnCredentialsSessionTokenGetData, ThrowOnError>) => (options.client ?? client).get<GetPublicTurnCredentialsApiV1PublicEmbedTurnCredentialsSessionTokenGetResponses, GetPublicTurnCredentialsApiV1PublicEmbedTurnCredentialsSessionTokenGetErrors, ThrowOnError>({ url: '/api/v1/public/embed/turn-credentials/{session_token}', ...options });

/**
 * Options Turn Credentials
 *
 * Handle CORS preflight for TURN credentials endpoint
 */
export const optionsTurnCredentialsApiV1PublicEmbedTurnCredentialsSessionTokenOptions = <ThrowOnError extends boolean = false>(options: Options<OptionsTurnCredentialsApiV1PublicEmbedTurnCredentialsSessionTokenOptionsData, ThrowOnError>) => (options.client ?? client).options<OptionsTurnCredentialsApiV1PublicEmbedTurnCredentialsSessionTokenOptionsResponses, OptionsTurnCredentialsApiV1PublicEmbedTurnCredentialsSessionTokenOptionsErrors, ThrowOnError>({ url: '/api/v1/public/embed/turn-credentials/{session_token}', ...options });

/**
 * Initiate Call
 *
 * Initiate a phone call against the published agent.
 *
 * Executes the workflow's currently released definition.
 */
export const initiateCallApiV1PublicAgentUuidPost = <ThrowOnError extends boolean = false>(options: Options<InitiateCallApiV1PublicAgentUuidPostData, ThrowOnError>) => (options.client ?? client).post<InitiateCallApiV1PublicAgentUuidPostResponses, InitiateCallApiV1PublicAgentUuidPostErrors, ThrowOnError>({
    url: '/api/v1/public/agent/{uuid}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Initiate Call Test
 *
 * Initiate a phone call against the latest draft of the agent.
 *
 * Useful for verifying changes before publishing. Falls back to the
 * published definition when no draft exists.
 */
export const initiateCallTestApiV1PublicAgentTestUuidPost = <ThrowOnError extends boolean = false>(options: Options<InitiateCallTestApiV1PublicAgentTestUuidPostData, ThrowOnError>) => (options.client ?? client).post<InitiateCallTestApiV1PublicAgentTestUuidPostResponses, InitiateCallTestApiV1PublicAgentTestUuidPostErrors, ThrowOnError>({
    url: '/api/v1/public/agent/test/{uuid}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Initiate Call By Workflow Uuid
 *
 * Initiate a phone call against the published workflow identified by UUID.
 */
export const initiateCallByWorkflowUuidApiV1PublicAgentWorkflowWorkflowUuidPost = <ThrowOnError extends boolean = false>(options: Options<InitiateCallByWorkflowUuidApiV1PublicAgentWorkflowWorkflowUuidPostData, ThrowOnError>) => (options.client ?? client).post<InitiateCallByWorkflowUuidApiV1PublicAgentWorkflowWorkflowUuidPostResponses, InitiateCallByWorkflowUuidApiV1PublicAgentWorkflowWorkflowUuidPostErrors, ThrowOnError>({
    url: '/api/v1/public/agent/workflow/{workflow_uuid}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Initiate Call Test By Workflow Uuid
 *
 * Initiate a phone call against the latest draft of the workflow by UUID.
 */
export const initiateCallTestByWorkflowUuidApiV1PublicAgentTestWorkflowWorkflowUuidPost = <ThrowOnError extends boolean = false>(options: Options<InitiateCallTestByWorkflowUuidApiV1PublicAgentTestWorkflowWorkflowUuidPostData, ThrowOnError>) => (options.client ?? client).post<InitiateCallTestByWorkflowUuidApiV1PublicAgentTestWorkflowWorkflowUuidPostResponses, InitiateCallTestByWorkflowUuidApiV1PublicAgentTestWorkflowWorkflowUuidPostErrors, ThrowOnError>({
    url: '/api/v1/public/agent/test/workflow/{workflow_uuid}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Download Workflow Artifact
 *
 * Download a workflow recording or transcript via public access token.
 *
 * This endpoint:
 * 1. Validates the public access token
 * 2. Looks up the corresponding workflow run
 * 3. Generates a signed URL for the requested artifact
 * 4. Redirects to the signed URL
 *
 * Args:
 * token: The public access token (UUID format)
 * artifact_type: Type of artifact - "recording" or "transcript"
 * inline: If true, sets Content-Disposition to inline for browser preview
 *
 * Returns:
 * RedirectResponse to the signed URL (302 redirect)
 *
 * Raises:
 * HTTPException 404: If token is invalid or artifact not found
 */
export const downloadWorkflowArtifactApiV1PublicDownloadWorkflowTokenArtifactTypeGet = <ThrowOnError extends boolean = false>(options: Options<DownloadWorkflowArtifactApiV1PublicDownloadWorkflowTokenArtifactTypeGetData, ThrowOnError>) => (options.client ?? client).get<DownloadWorkflowArtifactApiV1PublicDownloadWorkflowTokenArtifactTypeGetResponses, DownloadWorkflowArtifactApiV1PublicDownloadWorkflowTokenArtifactTypeGetErrors, ThrowOnError>({ url: '/api/v1/public/download/workflow/{token}/{artifact_type}', ...options });

/**
 * Deactivate Embed Token
 *
 * Deactivate the embed token for a workflow.
 */
export const deactivateEmbedTokenApiV1WorkflowWorkflowIdEmbedTokenDelete = <ThrowOnError extends boolean = false>(options: Options<DeactivateEmbedTokenApiV1WorkflowWorkflowIdEmbedTokenDeleteData, ThrowOnError>) => (options.client ?? client).delete<DeactivateEmbedTokenApiV1WorkflowWorkflowIdEmbedTokenDeleteResponses, DeactivateEmbedTokenApiV1WorkflowWorkflowIdEmbedTokenDeleteErrors, ThrowOnError>({ url: '/api/v1/workflow/{workflow_id}/embed-token', ...options });

/**
 * Get Embed Token
 *
 * Get the embed token for a workflow if it exists.
 */
export const getEmbedTokenApiV1WorkflowWorkflowIdEmbedTokenGet = <ThrowOnError extends boolean = false>(options: Options<GetEmbedTokenApiV1WorkflowWorkflowIdEmbedTokenGetData, ThrowOnError>) => (options.client ?? client).get<GetEmbedTokenApiV1WorkflowWorkflowIdEmbedTokenGetResponses, GetEmbedTokenApiV1WorkflowWorkflowIdEmbedTokenGetErrors, ThrowOnError>({ url: '/api/v1/workflow/{workflow_id}/embed-token', ...options });

/**
 * Create Or Update Embed Token
 *
 * Create or update an embed token for a workflow.
 * Each workflow can have only one active embed token.
 */
export const createOrUpdateEmbedTokenApiV1WorkflowWorkflowIdEmbedTokenPost = <ThrowOnError extends boolean = false>(options: Options<CreateOrUpdateEmbedTokenApiV1WorkflowWorkflowIdEmbedTokenPostData, ThrowOnError>) => (options.client ?? client).post<CreateOrUpdateEmbedTokenApiV1WorkflowWorkflowIdEmbedTokenPostResponses, CreateOrUpdateEmbedTokenApiV1WorkflowWorkflowIdEmbedTokenPostErrors, ThrowOnError>({
    url: '/api/v1/workflow/{workflow_id}/embed-token',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get presigned URL for document upload
 *
 * Generate a presigned PUT URL for uploading a document.
 *
 * This endpoint:
 * 1. Generates a unique document UUID for organizing the S3 key
 * 2. Generates a presigned S3/MinIO URL for uploading the file
 * 3. Returns the upload URL and document metadata
 *
 * After uploading to the returned URL, call /process-document to create
 * the document record and trigger processing.
 *
 * Access Control:
 * * All authenticated users can upload documents scoped to their organization.
 */
export const getUploadUrlApiV1KnowledgeBaseUploadUrlPost = <ThrowOnError extends boolean = false>(options: Options<GetUploadUrlApiV1KnowledgeBaseUploadUrlPostData, ThrowOnError>) => (options.client ?? client).post<GetUploadUrlApiV1KnowledgeBaseUploadUrlPostResponses, GetUploadUrlApiV1KnowledgeBaseUploadUrlPostErrors, ThrowOnError>({
    url: '/api/v1/knowledge-base/upload-url',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Trigger document processing
 *
 * Trigger asynchronous processing of an uploaded document.
 *
 * This endpoint should be called after successfully uploading a file to the presigned URL.
 * It will:
 * 1. Create a document record in the database with the specified UUID
 * 2. Enqueue a background task to process the document (chunking and embedding)
 *
 * The document status will be updated from 'pending' -> 'processing' -> 'completed' or 'failed'.
 *
 * Embedding:
 * Uses OpenAI text-embedding-3-small (1536-dimensional embeddings, requires API key configured in Model Configurations).
 *
 * Access Control:
 * * Users can only process documents in their organization.
 */
export const processDocumentApiV1KnowledgeBaseProcessDocumentPost = <ThrowOnError extends boolean = false>(options: Options<ProcessDocumentApiV1KnowledgeBaseProcessDocumentPostData, ThrowOnError>) => (options.client ?? client).post<ProcessDocumentApiV1KnowledgeBaseProcessDocumentPostResponses, ProcessDocumentApiV1KnowledgeBaseProcessDocumentPostErrors, ThrowOnError>({
    url: '/api/v1/knowledge-base/process-document',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List documents
 *
 * List all documents for the user's organization.
 *
 * Access Control:
 * * Users can only see documents from their organization.
 */
export const listDocumentsApiV1KnowledgeBaseDocumentsGet = <ThrowOnError extends boolean = false>(options?: Options<ListDocumentsApiV1KnowledgeBaseDocumentsGetData, ThrowOnError>) => (options?.client ?? client).get<ListDocumentsApiV1KnowledgeBaseDocumentsGetResponses, ListDocumentsApiV1KnowledgeBaseDocumentsGetErrors, ThrowOnError>({ url: '/api/v1/knowledge-base/documents', ...options });

/**
 * Delete document
 *
 * Soft delete a document and its chunks.
 *
 * Access Control:
 * * Users can only delete documents from their organization.
 */
export const deleteDocumentApiV1KnowledgeBaseDocumentsDocumentUuidDelete = <ThrowOnError extends boolean = false>(options: Options<DeleteDocumentApiV1KnowledgeBaseDocumentsDocumentUuidDeleteData, ThrowOnError>) => (options.client ?? client).delete<DeleteDocumentApiV1KnowledgeBaseDocumentsDocumentUuidDeleteResponses, DeleteDocumentApiV1KnowledgeBaseDocumentsDocumentUuidDeleteErrors, ThrowOnError>({ url: '/api/v1/knowledge-base/documents/{document_uuid}', ...options });

/**
 * Get document details
 *
 * Get details of a specific document.
 *
 * Access Control:
 * * Users can only access documents from their organization.
 */
export const getDocumentApiV1KnowledgeBaseDocumentsDocumentUuidGet = <ThrowOnError extends boolean = false>(options: Options<GetDocumentApiV1KnowledgeBaseDocumentsDocumentUuidGetData, ThrowOnError>) => (options.client ?? client).get<GetDocumentApiV1KnowledgeBaseDocumentsDocumentUuidGetResponses, GetDocumentApiV1KnowledgeBaseDocumentsDocumentUuidGetErrors, ThrowOnError>({ url: '/api/v1/knowledge-base/documents/{document_uuid}', ...options });

/**
 * Search for similar chunks
 *
 * Search for document chunks similar to the query.
 *
 * This endpoint uses vector similarity search to find relevant chunks.
 * Results are returned without threshold filtering - apply similarity
 * thresholds at the application layer after optional reranking.
 *
 * Access Control:
 * * Users can only search documents from their organization.
 */
export const searchChunksApiV1KnowledgeBaseSearchPost = <ThrowOnError extends boolean = false>(options: Options<SearchChunksApiV1KnowledgeBaseSearchPostData, ThrowOnError>) => (options.client ?? client).post<SearchChunksApiV1KnowledgeBaseSearchPostResponses, SearchChunksApiV1KnowledgeBaseSearchPostErrors, ThrowOnError>({
    url: '/api/v1/knowledge-base/search',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get presigned URLs for recording uploads
 *
 * Generate presigned PUT URLs for uploading one or more audio recordings.
 */
export const getUploadUrlsApiV1WorkflowRecordingsUploadUrlPost = <ThrowOnError extends boolean = false>(options: Options<GetUploadUrlsApiV1WorkflowRecordingsUploadUrlPostData, ThrowOnError>) => (options.client ?? client).post<GetUploadUrlsApiV1WorkflowRecordingsUploadUrlPostResponses, GetUploadUrlsApiV1WorkflowRecordingsUploadUrlPostErrors, ThrowOnError>({
    url: '/api/v1/workflow-recordings/upload-url',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List recordings
 *
 * List recordings for the organization, optionally filtered.
 */
export const listRecordingsApiV1WorkflowRecordingsGet = <ThrowOnError extends boolean = false>(options?: Options<ListRecordingsApiV1WorkflowRecordingsGetData, ThrowOnError>) => (options?.client ?? client).get<ListRecordingsApiV1WorkflowRecordingsGetResponses, ListRecordingsApiV1WorkflowRecordingsGetErrors, ThrowOnError>({ url: '/api/v1/workflow-recordings/', ...options });

/**
 * Create recording records after upload
 *
 * Create one or more recording records after audio files have been uploaded.
 */
export const createRecordingsApiV1WorkflowRecordingsPost = <ThrowOnError extends boolean = false>(options: Options<CreateRecordingsApiV1WorkflowRecordingsPostData, ThrowOnError>) => (options.client ?? client).post<CreateRecordingsApiV1WorkflowRecordingsPostResponses, CreateRecordingsApiV1WorkflowRecordingsPostErrors, ThrowOnError>({
    url: '/api/v1/workflow-recordings/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete a recording
 *
 * Soft delete a recording.
 */
export const deleteRecordingApiV1WorkflowRecordingsRecordingIdDelete = <ThrowOnError extends boolean = false>(options: Options<DeleteRecordingApiV1WorkflowRecordingsRecordingIdDeleteData, ThrowOnError>) => (options.client ?? client).delete<DeleteRecordingApiV1WorkflowRecordingsRecordingIdDeleteResponses, DeleteRecordingApiV1WorkflowRecordingsRecordingIdDeleteErrors, ThrowOnError>({ url: '/api/v1/workflow-recordings/{recording_id}', ...options });

/**
 * Update a recording's Recording ID
 *
 * Update the recording_id (descriptive name) of a recording.
 */
export const updateRecordingApiV1WorkflowRecordingsIdPatch = <ThrowOnError extends boolean = false>(options: Options<UpdateRecordingApiV1WorkflowRecordingsIdPatchData, ThrowOnError>) => (options.client ?? client).patch<UpdateRecordingApiV1WorkflowRecordingsIdPatchResponses, UpdateRecordingApiV1WorkflowRecordingsIdPatchErrors, ThrowOnError>({
    url: '/api/v1/workflow-recordings/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Transcribe an audio file
 *
 * Transcribe an uploaded audio file using MPS STT.
 */
export const transcribeAudioApiV1WorkflowRecordingsTranscribePost = <ThrowOnError extends boolean = false>(options: Options<TranscribeAudioApiV1WorkflowRecordingsTranscribePostData, ThrowOnError>) => (options.client ?? client).post<TranscribeAudioApiV1WorkflowRecordingsTranscribePostResponses, TranscribeAudioApiV1WorkflowRecordingsTranscribePostErrors, ThrowOnError>({
    ...formDataBodySerializer,
    url: '/api/v1/workflow-recordings/transcribe',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * List Folders
 *
 * List all folders in the authenticated user's organization.
 */
export const listFoldersApiV1FolderGet = <ThrowOnError extends boolean = false>(options?: Options<ListFoldersApiV1FolderGetData, ThrowOnError>) => (options?.client ?? client).get<ListFoldersApiV1FolderGetResponses, ListFoldersApiV1FolderGetErrors, ThrowOnError>({ url: '/api/v1/folder/', ...options });

/**
 * Create Folder
 *
 * Create a new folder in the authenticated user's organization.
 */
export const createFolderApiV1FolderPost = <ThrowOnError extends boolean = false>(options: Options<CreateFolderApiV1FolderPostData, ThrowOnError>) => (options.client ?? client).post<CreateFolderApiV1FolderPostResponses, CreateFolderApiV1FolderPostErrors, ThrowOnError>({
    url: '/api/v1/folder/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Folder
 *
 * Delete a folder. Member agents are moved to "Uncategorized", not deleted.
 */
export const deleteFolderApiV1FolderFolderIdDelete = <ThrowOnError extends boolean = false>(options: Options<DeleteFolderApiV1FolderFolderIdDeleteData, ThrowOnError>) => (options.client ?? client).delete<DeleteFolderApiV1FolderFolderIdDeleteResponses, DeleteFolderApiV1FolderFolderIdDeleteErrors, ThrowOnError>({ url: '/api/v1/folder/{folder_id}', ...options });

/**
 * Rename Folder
 *
 * Rename a folder owned by the authenticated user's organization.
 */
export const renameFolderApiV1FolderFolderIdPut = <ThrowOnError extends boolean = false>(options: Options<RenameFolderApiV1FolderFolderIdPutData, ThrowOnError>) => (options.client ?? client).put<RenameFolderApiV1FolderFolderIdPutResponses, RenameFolderApiV1FolderFolderIdPutErrors, ThrowOnError>({
    url: '/api/v1/folder/{folder_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Signup
 */
export const signupApiV1AuthSignupPost = <ThrowOnError extends boolean = false>(options: Options<SignupApiV1AuthSignupPostData, ThrowOnError>) => (options.client ?? client).post<SignupApiV1AuthSignupPostResponses, SignupApiV1AuthSignupPostErrors, ThrowOnError>({
    url: '/api/v1/auth/signup',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Login
 */
export const loginApiV1AuthLoginPost = <ThrowOnError extends boolean = false>(options: Options<LoginApiV1AuthLoginPostData, ThrowOnError>) => (options.client ?? client).post<LoginApiV1AuthLoginPostResponses, LoginApiV1AuthLoginPostErrors, ThrowOnError>({
    url: '/api/v1/auth/login',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Current User
 */
export const getCurrentUserApiV1AuthMeGet = <ThrowOnError extends boolean = false>(options?: Options<GetCurrentUserApiV1AuthMeGetData, ThrowOnError>) => (options?.client ?? client).get<GetCurrentUserApiV1AuthMeGetResponses, GetCurrentUserApiV1AuthMeGetErrors, ThrowOnError>({ url: '/api/v1/auth/me', ...options });

/**
 * List Node Types
 *
 * List every registered NodeSpec.
 *
 * SDK clients should pin to `spec_version` and warn if the server reports
 * a higher version than what they were generated against.
 */
export const listNodeTypesApiV1NodeTypesGet = <ThrowOnError extends boolean = false>(options?: Options<ListNodeTypesApiV1NodeTypesGetData, ThrowOnError>) => (options?.client ?? client).get<ListNodeTypesApiV1NodeTypesGetResponses, ListNodeTypesApiV1NodeTypesGetErrors, ThrowOnError>({ url: '/api/v1/node-types', ...options });

/**
 * Get Node Type
 */
export const getNodeTypeApiV1NodeTypesNameGet = <ThrowOnError extends boolean = false>(options: Options<GetNodeTypeApiV1NodeTypesNameGetData, ThrowOnError>) => (options.client ?? client).get<GetNodeTypeApiV1NodeTypesNameGetResponses, GetNodeTypeApiV1NodeTypesNameGetErrors, ThrowOnError>({ url: '/api/v1/node-types/{name}', ...options });

/**
 * Health
 */
export const healthApiV1HealthGet = <ThrowOnError extends boolean = false>(options?: Options<HealthApiV1HealthGetData, ThrowOnError>) => (options?.client ?? client).get<HealthApiV1HealthGetResponses, HealthApiV1HealthGetErrors, ThrowOnError>({ url: '/api/v1/health', ...options });
